export default {

    // Utility Methods
    JsonCopy: function(Value) {

        return JSON.parse(JSON.stringify(Value))
    },

    gotoRoute(DOM, data) {
        DOM.$router.push({
            path: data
        })
    },

    tabDefaultState: function(TabInfo) {
        TabInfo.TabDetails.filter(function(item) {
            if (item.isDefaultSelectedTab) {
                var element = document.getElementById(item.id);
                element.classList.add("tabChecked-tablabel");
                item.isTabEnable = true;
            } else if (item.isDisabled) {
                var element = document.getElementById(item.id);
                element.classList.add("V-tab-disabled");
            } else {
                var removedElement = document.getElementById(item.id);
                for (var i = 0; i < removedElement.classList.length; i++) {
                    if (removedElement.classList[i] == "tabChecked-tablabel") {
                        removedElement.classList.remove("tabChecked-tablabel");
                        item.isTabEnable = false;
                    }
                }
            }
        })
    },

    tabMessage: function(tab) {
        if (tab.isDisabled)
            return tab.ErrorMessage;
        else
            return ""
    },

    tabSelected: function(selectedTab, TabList) {
        if (!selectedTab.isDisabled) {
            TabList.filter(function(item) {
                var element = document.getElementById(selectedTab.id);
                if (selectedTab.id == item.id) {
                    element.classList.add("tabChecked-tablabel");
                    item.isTabEnable = true;
                } else {
                    var removedElement = document.getElementById(item.id);
                    for (var i = 0; i < removedElement.classList.length; i++) {
                        if (removedElement.classList[i] == "tabChecked-tablabel") {
                            removedElement.classList.remove("tabChecked-tablabel");
                            item.isTabEnable = false;
                        }
                    }
                }
            })

            return TabList;
        }
    },

    // <onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 47 && event.charCode <= 57) || event.charCode == 46 || event.charCode==95 " placeholder="Reference No"></b-form-input>

    IsNotNullOrEmptyOrUndefined: function(Value) {
        var result = false;
        if (Value != null && Value != "" && Value != undefined && Value != "0.00") {
            result = true;
        } else {
            result = false;
        }
        return result;
    },
    IsValidMobile: function(mobileNumber) {
        var result = false;
        if (this.IsNotNullOrEmptyOrUndefined(mobileNumber)) {
            var mobile = mobileNumber;
            if (mobile.length >= 10 && mobile.length <= 12)
                result = true;
            else
                result = false;
        } else {

            result = false;
        }
        return result;
    },

    stringRangeValidation: function(data, min, max) {

        var result = false;

        if (this.IsNotNullOrEmptyOrUndefined(data)) {
            var fromData = data;
            if (fromData.length >= min || fromData.length <= max)
                result = true;
            else
                result = false;
        } else
            result = false;

        return result;

    },

    IsValidEmailID: function(email) {
        var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        return (!this.IsNotNullOrEmptyOrUndefined(email)) ? false : (reg.test(email)) ? true : false;
        //By Mani
        //note : first we chech the data of email is not empty if it is empty return false after that i check with Email pattern

    },
    IsValidOptionalEmailId: function(email) {
        var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        return (!this.IsNotNullOrEmptyOrUndefined(email)) ? true : (reg.test(email)) ? true : false;
        //By Mani
        //note : this method is check the mailid is valid or not, if it is empty return true . this method for only optional field

    },

    IsValidWebSite: function(URL) {
        return (!this.IsNotNullOrEmptyOrUndefined(URL)) ? false : (this.WebsitePattern().test(URL)) ? true : false;
        //By Mani
        //note : first we chech the data of URL is not empty if it is empty return false after that i check with URL pattern
        // return (URL == "") ? "" : (this.WebsitePattern().test(URL)) ? true : false;
    },

    IsValidOptionalWebSite: function(URL) {
        return (!this.IsNotNullOrEmptyOrUndefined(URL)) ? true : (this.WebsitePattern().test(URL)) ? true : false;
        //By Mani
        //note : first we chech the data of URL is not empty if it is empty return false after that i check with URL pattern
        // return (URL == "") ? "" : (this.WebsitePattern().test(URL)) ? true : false;
    },


    AutoCaps: function(Value) {
        return Value;
    },

    getPagedDataAsync: function(pageSize, page, gridData, searchText) {
        var data, result;
        if (searchText) {
            var ft = searchText.toLowerCase();
            data = gridData.filter(function(item) {
                return (
                    JSON.stringify(item)
                    .toLowerCase()
                    .indexOf(ft) != -1
                );
            });
            result = data.slice((page - 1) * pageSize, page * pageSize);
        } else {
            if (gridData != null) {
                result = gridData.slice((page - 1) * pageSize, page * pageSize);
            }
        }
        return result;
    },

    //For Description fields -> done by mani
    afterDotCaps: function(key) {

        if (key.keyCode >= 65 && key.keyCode <= 122) {
            var ctrl = key.currentTarget
            var position = key.currentTarget.selectionStart;
            if (ctrl.textLength > 0 && key.currentTarget.selectionStart > 0) {
                var str = ctrl.value;
                if (ctrl.textLength != key.currentTarget.selectionStart) {

                    var data = str.slice(position - 3, position)
                    var dot = data.substring(0, 1); //letter one
                    var space = data.substring(2, 1); //letter one

                    if (dot === '.') {
                        var chk = data;
                        var che = data;
                        if (che !== undefined) {
                            dot = chk.substring(0, 1); //letter one
                            uchar = chk.substring(2, 1); //letter two
                            thr = chk.substring(2, 3); //letter three
                            if (che.length === 1) {
                                che = che.toUpperCase();
                                che = che;
                            } else {
                                if (dot === ".") {
                                    if (uchar.match(" ")) {
                                        che = che.slice(0, che.length - 1) + thr.toUpperCase();
                                    } else {
                                        che = che.slice(0, che.length - 2) + " " + uchar.toUpperCase() + thr;
                                    }
                                }
                            }
                        }

                        b = che;

                        key.currentTarget.value = [str.slice(0, position - 3), b, str.slice(position)].join('');
                        if (space == ' ') {
                            key.currentTarget.selectionStart = position;
                            key.currentTarget.selectionEnd = position;
                        } else {
                            key.currentTarget.selectionStart = position + 1;
                            key.currentTarget.selectionEnd = position + 1;
                        }
                    }
                } else {
                    var chk = ctrl.value;
                    var che = ctrl.value;
                    if (che !== undefined) {
                        chk = che.slice(che.length - 3);
                        dot = chk.substring(0, 1); //letter one

                        uchar = chk.substring(2, 1); //letter two

                        thr = chk.substring(2, 3); //letter three
                        if (che.length === 1) {
                            che = che.toUpperCase();
                            che = che;
                        } else {
                            if (dot === ".") {
                                if (uchar.match(" ")) {
                                    che = che.slice(0, che.length - 1) + thr.toUpperCase();
                                } else {
                                    che = che.slice(0, che.length - 2) + " " + uchar.toUpperCase() + thr;
                                }
                            }
                        }
                    }

                    key.currentTarget.value = che;
                    key.currentTarget.selectionStart = position + 1;
                    key.currentTarget.selectionEnd = position + 1;

                }
            }
        }


    },

    GetMonth: function(Month) {
        var month = new Array();
        month[0] = "Jan";
        month[1] = "Feb";
        month[2] = "Mar";
        month[3] = "Apr";
        month[4] = "May";
        month[5] = "Jun";
        month[6] = "Jul";
        month[7] = "Aug";
        month[8] = "Sep";
        month[9] = "Oct";
        month[10] = "Nov";
        month[11] = "Dec";

        return month[Month];

    },

    //return by Maxi
    equalsIgnoreCase: function(str1, str2) {
        if (this.isNotUndefindeOrEmpty(str2))
            return str1.toUpperCase() === str2.toUpperCase();
        else
            return false

    },

    selectFromList: function(Data, datalist, attr) {
        var Object = null;
        datalist.map(function(value, key) {
            if (Data == value[attr]) {
                Object = value;
            }
        });

        if (Object == null) {
            Object = {
                Id: 0,
                Name: null,
            }
            Object[attr] = Data;
        }
        return Object;
    },

    selectFromListWithoutCase: function(Data, datalist, attr) {
        var Object = null;
        datalist.map(function(value, key) {
            if (Data.toUpperCase() == value[attr].toUpperCase()) {
                Object = value;
            }
        });

        if (Object == null) {
            Object = {
                Id: 0,
                Name: null,
            }
            Object[attr] = Data;
        }
        return Object;
    },

    Getdayofweek: function(Day) {
        var dayvalue = null;

        switch (Day) {
            case '0':
                dayvalue = 'Sunday';
                break;
            case '1':
                dayvalue = 'Monday';
                break;
            case '2':
                dayvalue = 'Tuesday';
                break;
            case '3':
                dayvalue = 'Wednesday';
                break;
            case '4':
                dayvalue = 'Thursday';
                break;
            case '5':
                dayvalue = 'Friday';
                break;
            case '6':
                dayvalue = 'Saturday';
                break;
        }

        return dayvalue;
    },

    DateFormat(date) {
        var Completedate = "";
        if (this.IsNotNullOrEmptyOrUndefined(date)) {
            Completedate = date.getDate() + "-" + date.getMonth() + "-" + date.getFullYear()
            return Completedate;
        } else {
            return Completedate;
        }
    },



    DateFormaterVue: function(Data) {

        if (Data != null && Data != undefined && Data != "") {
            var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
            var DateFormat = AppData.DateFormat;
            var DateSeperator = AppData.DateSeperator;
            var FormatedDate = {
                date: null,
                Month: null,
                Year: null,
                ComlpeteDate: null
            };

            switch (DateFormat) {
                case 'yy M dd':
                    var str = "yyyy MMM dd";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
                case 'M yy dd':
                    var str = "MMM yyyy dd";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
                case 'dd M yy':
                    var str = "dd MMM yyyy";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
                case 'yy dd M':
                    var str = "yyyy dd MMM";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
                case 'M dd yy':
                    var str = "MMM dd yyyy";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
            }



            return FormatedDate.ComlpeteDate;
        }
    },



    DateFormater: function(Data) {

        if (Data != null && Data != undefined && Data != "") {
            var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
            var DateFormat = AppData.DateFormat;
            var DateSeperator = AppData.DateSeperator;
            var FormatedDate = {
                date: null,
                Month: null,
                Year: null,
                ComlpeteDate: null
            };

            switch (DateFormat) {
                case 'yy M dd':
                    var str = "yyyy MMM dd";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
                case 'M yy dd':
                    var str = "MMM yyyy dd";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
                case 'dd M yy':
                    var str = "dd MMM yyyy";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
                case 'yy dd M':
                    var str = "yyyy dd MMM";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
                case 'M dd yy':
                    var str = "MMM dd yyyy";
                    if (str != undefined && DateSeperator != undefined) {
                        str = str.replace(/ /, DateSeperator);
                        DateFormat = str.replace(/ /, DateSeperator);
                    }
                    FormatedDate.ComlpeteDate = $filter("date")(new Date(Data), DateFormat);
                    break;
            }



            return FormatedDate.ComlpeteDate;
        }
    },

    //  Application Configuration Date Separation
    DateSeparatorBinder: function() {

        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var DateFormat = AppData.DateFormat;

        var DateSeperator = AppData.DateSeperator;
        var str = DateFormat;
        if (str != undefined && DateSeperator != undefined) {
            str = str.replace(/ /, DateSeperator);
            DateFormat = str.replace(/ /, DateSeperator);
        }
        return DateFormat;
    },

    isNotUndefindeOrEmpty: function(data) {
        var result = false;
        if (data != undefined && data != 'undefined' && data != "" && data != null && data != "null" && data != " ") {
            result = true;
        } else
            result = false;

        return result;
    },

    isNotZeroOrEmpty: function(data) {
        var result = false;
        var text = 0;
        var digits = this.CurrencyFormatText(0);
        if (this.isNotUndefindeOrEmpty(data)) {
            if (
                number != undefined &&
                number != digits &&
                number != null &&
                number != "" &&
                number != 0
            ) {
                var c = number.toString();
                text = c.replace(/\,/g, "");
                text = parseFloat(text);
                //Data = text.replace(/\$/g, "");
            }
        }

        return result;
    },

    // This convert function will be converted integer(Number) format to create method calling
    convert: function(number) {
        var text = 0;
        if (number != undefined && number != "0.00" && number != null && number != "" && number != 0) {
            var c = number.toString();
            text = c.replace(/\,/g, "");
        }
        return text;
    },


    ConvertToNumber: function(number) {

        var text = 0;
        var digits = this.CurrencyFormatText(0);
        if (
            number != undefined &&
            number != digits &&
            number != null &&
            number != "" &&
            number != 0
        ) {
            var c = number.toString();
            text = c.replace(/\,/g, "");
            text = parseFloat(text);
        }
        return text;
    },

    convertQuantity: function(number) {
        var text = 0;
        if (number != undefined && number != "0.00" && number != null && number != "" && number != 0) {
            var c = number.toString();
            text = c.replace(/\,/g, "");
        }
        return text;
    },


    // For Percentage Text Box
    PercentageTextBox: function(Data) {
        if (Data > 100) {
            if (Data != null && Data != undefined) {
                Data = Data.slice(0, -1);
            }
        }
        return Data;
    },

    convertToDigit: function(number) {
        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var cSymbol = AppData.BaseCurrency.Symbol;
        var transactionCurrencySymbol = $window.sessionStorage.getItem("transactionCurrencySymbol");
        var currencyforGrid = $window.sessionStorage.getItem("transactionCurrencyCode");
        var SymbolofCurrency = null;
        if (transactionCurrencySymbol != "null" && transactionCurrencySymbol != undefined && transactionCurrencySymbol != null)
            SymbolofCurrency = transactionCurrencySymbol;
        else if (cSymbol != null && CustomerCurrencyCode != currencyforGrid)
            SymbolofCurrency = cSymbol;
        else
            SymbolofCurrency = "";
        var Data = 0;
        if (number != undefined && number != null && number == '.')
            number = 0.00;

        if (number != undefined &&
            number != "0.00" &&
            number != null &&
            number != "" &&
            number != 0) {
            var c = number.toString();
            var text = c.replace(/\,/g, "");
            text = text.replace(SymbolofCurrency, "");
            Data = text.replace(" ", "");
            Data = Number(Data);
        }
        return Data;
    },

    convertToDigitFromNegative: function(number) {
        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var cSymbol = AppData.BaseCurrency.Symbol;
        var transactionCurrencySymbol = $window.sessionStorage.getItem("transactionCurrencySymbol");
        var currencyforGrid = $window.sessionStorage.getItem("transactionCurrencyCode");
        var SymbolofCurrency = null;
        if (transactionCurrencySymbol != "null" && transactionCurrencySymbol != undefined && transactionCurrencySymbol != null)
            SymbolofCurrency = transactionCurrencySymbol;
        else if (cSymbol != null && CustomerCurrencyCode != currencyforGrid)
            SymbolofCurrency = cSymbol;
        else
            SymbolofCurrency = "";
        var Data = 0;
        if (number != undefined && number != null && number == '.')
            number = 0.00;

        if (number != undefined &&
            number != "0.00" &&
            number != null &&
            number != "" &&
            number != 0) {
            var c = number.toString();
            var text = c.replace(/\,/g, "");
            text = text.replace(SymbolofCurrency, "");
            Data = text.replace(" ", "");
            Data = Data.replace("(", "-");
            Data = Data.replace(")", "");
        }
        return Data;
    },

    convertToDigitTransaction: function(number) {
        /// var cSymbol = $window.sessionStorage.getItem("transactionCurrencySymbol");

        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var cSymbol = AppData.BaseCurrency.Symbol;

        var transactionCurrencySymbol = $window.sessionStorage.getItem("transactionCurrencySymbol");
        var currencyforGrid = $window.sessionStorage.getItem("transactionCurrencyCode");
        var SymbolofCurrency = null;
        if (transactionCurrencySymbol != "null" && transactionCurrencySymbol != undefined && transactionCurrencySymbol != null)
            SymbolofCurrency = transactionCurrencySymbol;
        else if (cSymbol != null && CustomerCurrencyCode != currencyforGrid)
            SymbolofCurrency = cSymbol;
        else
            SymbolofCurrency = "";

        var Data = 0;
        if (
            number != undefined &&
            number != "0.00" &&
            number != null &&
            number != "" &&
            number != 0
        ) {
            var c = number.toString();
            var text = c.replace(/\,/g, "");
            Data = text.replace(SymbolofCurrency, "");
        }
        return Data;
    },

    PercentageSign: function(Data) {
        console.log("PercentageSign");
        if (Data != null && Data != undefined && Data != "") {
            Data = parseFloat(Data).toFixed(2);
            Data = Data + " %";
        } else {
            Data = "0.00 " + "%";
        }

        return Data;
    },

    // return Pattern for Email validation purpose
    EmailPattern: function() {
        return /^[A-Za-z0-9_\.-]{0,49}[A-Za-z0-9]@[A-Za-z0-9]{0,}[A-Za-z0-9_\.-]{0,}[A-Za-z0-9][\.][A-Za-z0-9]{2,4}$/;
    },

    // return Pattern for Website validation purpose
    WebsitePattern: function() {
        // return /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;

        return /^((http|https|ftp):\/\/(www\.)?|www\.)[a-zA-Z0-9\_\-]+\.([a-zA-Z]{2,4}|[a-zA-Z]{2}\.[a-zA-Z]{2})(\/[a-zA-Z0-9\-\._\?\&=,'\+%\$#~]*)*$/;
    },

    Documentvalidator: function(DocumentType, ReferenceNumber) {
        var result = false;

        switch (DocumentType) {
            case "GSTIN":
                result = this.GSTIN_validator(ReferenceNumber);
                break;
            case "PAN":
                result = this.PAN_validator(ReferenceNumber);
                break;
            case "CIN":
                result = this.GSTIN_validator(ReferenceNumber);
                break;
        }
        return result;
    },



    compareValues: function(key, order = 'asc') {
        return function(a, b) {
            if (!a.hasOwnProperty(key) ||
                !b.hasOwnProperty(key)) {
                return 0;
            }

            const varA = (typeof a[key] === 'string') ?
                a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string') ?
                b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                (order == 'desc') ?
                (comparison * -1) : comparison
            );
        };
    },

    PAN_validator: function(DocRefNo) {
        var regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        return (!this.IsNotNullOrEmptyOrUndefined(DocRefNo)) ? false : (regpan.test(DocRefNo)) ? true : false;
    },

    AccountNumber_validator: function(AccountNumber) {
        var regAcNo = /^\d{9,18}$/;
        return (!this.IsNotNullOrEmptyOrUndefined(AccountNumber)) ? false : (regAcNo.test(AccountNumber)) ? true : false;
    },

    IFSC_validator: function(IFSC) {
        var regIFSC =/[A-Z|a-z]{4}[0][a-zA-Z0-9]{6}$/; 
        return (!this.IsNotNullOrEmptyOrUndefined(IFSC)) ? false : (regIFSC.test(IFSC)) ? true : false;
    },

    


    GSTIN_validator: function(DocRefNo) {
        var gstin = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[0-9a-zA-Z]{1}[0-9a-zA-Z]{1})+$/;
        return (!this.IsNotNullOrEmptyOrUndefined(DocRefNo)) ? false : (gstin.test(DocRefNo)) ? true : false;
    },


    CIN_validator: function(DocRefNo) {
        var cin = /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/;
        return (!this.IsNotNullOrEmptyOrUndefined(DocRefNo)) ? false : (cin.test(DocRefNo)) ? true : false;
    },


    convertToDigitVue: function(number) {

        var cSymbol = this.GetSession("BaseCurrencySymbol");
        var transactionCurrencySymbol = this.GetSession("TransactionCurrencySymbol");
        var currencyforGrid = this.GetSession("BaseCurrencySymbol");
        var SymbolofCurrency = null;
        if (transactionCurrencySymbol != "null" && transactionCurrencySymbol != undefined && transactionCurrencySymbol != null)
            SymbolofCurrency = transactionCurrencySymbol;
        else if (cSymbol != null)
            SymbolofCurrency = cSymbol;
        else
            SymbolofCurrency = "";
        var Data = 0;
        if (number != undefined && number != null && number == '.')
            number = 0.00;

        if (number != undefined &&
            number != "0.00" &&
            number != null &&
            number != "" &&
            number != 0) {
            var c = number.toString();
            var text = c.replace(/\,/g, "");
            text = text.replace(SymbolofCurrency, "");
            Data = text.replace(" ", "");
            Data = text.replace("%", "");
            Data = Number(Data);
        } else
            Data = 0

        return Data;
    },

    // //Currency Format
    CurrencyFormat: function(number) {
        // var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        // var cSymbol = AppData.BaseCurrency.Symbol;
        // var decimalplaces = AppData.DecimalPoint;
        // var CurrencySysmbolOnRight = AppData.IsCurrencySymbolOnRight;
        // var IsThousandseparater = AppData.IsThousandSeperatorRequired;

        var cSymbol = this.GetSession("BaseCurrencySymbol");
        var decimalplaces = 2;
        var CurrencySysmbolOnRight = false;
        var IsThousandseparater = true;

        var transactionCurrencySymbol = this.GetSession("BaseCurrencySymbol");
        var currencyforGrid = this.GetSession("BaseCurrencyCode");
        var SymbolofCurrency = null;
        if (transactionCurrencySymbol != "null" && transactionCurrencySymbol != undefined && transactionCurrencySymbol != null)
            SymbolofCurrency = transactionCurrencySymbol;
        else if (cSymbol != null)
            SymbolofCurrency = cSymbol;
        else
            SymbolofCurrency = "";


        var CurrencySign = SymbolofCurrency + " ";

        if (number == undefined || number == null || number == '.' || number == "")
            number = 0.00;

        var Num = number;
        var finalCurrencyObj = null;
        if (number != undefined) {
            var decimalcharacter = ".";

            var thousandseparater = ",";
            if (IsThousandseparater == false)
                thousandseparater = "";
            else
                thousandseparater = ",";

            number = parseFloat(number);
            var sign = number < 0 ? "-" : "";

            var formatted = new String(number.toFixed(decimalplaces));
            if (decimalcharacter.length && decimalcharacter != ".") {
                formatted = formatted.replace(/\./, decimalcharacter);
            }
            var integer = "";
            var fraction = "";
            var strnumber = new String(formatted);
            var dotpos = decimalcharacter.length ?
                strnumber.indexOf(decimalcharacter) :
                -1;
            if (dotpos > -1) {
                if (dotpos) {
                    integer = strnumber.substr(0, dotpos);
                }
                fraction = strnumber.substr(dotpos + 1);
            } else {
                integer = strnumber;
            }
            if (integer) {
                integer = String(Math.abs(integer));
            }
            while (fraction.length < decimalplaces) {
                fraction += "0";
            }
            var temparray = new Array();
            while (integer.length > 3) {
                temparray.unshift(integer.substr(-3));
                integer = integer.substr(0, integer.length - 3);
            }
            temparray.unshift(integer);
            integer = temparray.join(thousandseparater);
            if (Num < 0) {
                if (CurrencySysmbolOnRight == true)
                    finalCurrencyObj = "(" + integer + decimalcharacter + fraction + " " + CurrencySign + ")";
                else
                    finalCurrencyObj = "(" + CurrencySign + integer + decimalcharacter + fraction + ")";
            } else {
                if (CurrencySysmbolOnRight == true)
                    finalCurrencyObj =
                    integer + decimalcharacter + fraction + " " + CurrencySign;
                else
                    finalCurrencyObj =
                    CurrencySign + integer + decimalcharacter + fraction;
            }
            return finalCurrencyObj;
        } else {
            if (CurrencySysmbolOnRight == true)
                return "0.00 " + CurrencySign;
            else
                return CurrencySign + " 0.00";
        }
    },

    CurrencyFormatforTrialBalance: function(number) {
        // var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var cSymbol = AppData.BaseCurrency.Symbol;
        var decimalplaces = AppData.DecimalPoint;
        var CurrencySysmbolOnRight = AppData.IsCurrencySymbolOnRight;
        var IsThousandseparater = AppData.IsThousandSeperatorRequired;

        var transactionCurrencySymbol = $window.sessionStorage.getItem("TransactionCurrencySymbol");
        var currencyforGrid = $window.sessionStorage.getItem("TransactionCurrencyCode");
        var SymbolofCurrency = null;

        if (transactionCurrencySymbol != "null" && transactionCurrencySymbol != undefined && transactionCurrencySymbol != null)
            SymbolofCurrency = transactionCurrencySymbol;
        else if (cSymbol != null && CustomerCurrencyCode != currencyforGrid)
            SymbolofCurrency = cSymbol;
        else
            SymbolofCurrency = "";


        var CurrencySign = SymbolofCurrency + " ";

        if (number != undefined && number != null && number == '.')
            number = 0.00;

        var Num = number;
        var finalCurrencyObj = null;
        if (number != undefined) {
            var decimalcharacter = ".";

            var thousandseparater = ",";
            if (IsThousandseparater == false)
                thousandseparater = "";
            else
                thousandseparater = ",";

            number = parseFloat(number);
            var sign = number < 0 ? "-" : "";

            var formatted = new String(number.toFixed(decimalplaces));
            if (decimalcharacter.length && decimalcharacter != ".") {
                formatted = formatted.replace(/\./, decimalcharacter);
            }
            var integer = "";
            var fraction = "";
            var strnumber = new String(formatted);
            var dotpos = decimalcharacter.length ?
                strnumber.indexOf(decimalcharacter) :
                -1;
            if (dotpos > -1) {
                if (dotpos) {
                    integer = strnumber.substr(0, dotpos);
                }
                fraction = strnumber.substr(dotpos + 1);
            } else {
                integer = strnumber;
            }
            if (integer) {
                integer = String(Math.abs(integer));
            }
            while (fraction.length < decimalplaces) {
                fraction += "0";
            }
            temparray = new Array();
            while (integer.length > 3) {
                temparray.unshift(integer.substr(-3));
                integer = integer.substr(0, integer.length - 3);
            }
            temparray.unshift(integer);
            integer = temparray.join(thousandseparater);
            if (CurrencySysmbolOnRight == true)
                finalCurrencyObj =
                integer + decimalcharacter + fraction + " " + CurrencySign;
            else
                finalCurrencyObj =
                CurrencySign + integer + decimalcharacter + fraction;
            return finalCurrencyObj;
        } else {
            if (CurrencySysmbolOnRight == true)
                return "0.00 " + CurrencySign;
            else
                return CurrencySign + " 0.00";
        }
    },


    CurrencyFormatgrid: function(number, existingCurrency) {
        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var cSymbol = AppData.BaseCurrency.Symbol;
        var decimalplaces = AppData.DecimalPoint;
        var CurrencySysmbolOnRight = AppData.IsCurrencySymbolOnRight;
        var IsThousandseparater = AppData.IsThousandSeperatorRequired;

        var transactionCurrencySymbol = $window.sessionStorage.getItem("transactionCurrencySymbol");
        var SymbolofCurrency = null;
        var currencyforGrid = $window.sessionStorage.getItem("transactionCurrencyCode");
        if (transactionCurrencySymbol != "null" && transactionCurrencySymbol != undefined && transactionCurrencySymbol != null)
            SymbolofCurrency = transactionCurrencySymbol;
        else if (cSymbol != null && CustomerCurrencyCode != currencyforGrid)
            SymbolofCurrency = cSymbol;
        else
            SymbolofCurrency = "";

        var CurrencySign = SymbolofCurrency + " ";

        if (number != undefined && number != null && number == '.')
            number = 0.00;
        var Num = number;
        var finalCurrencyObj = null;
        var temp = number;



        if (
            number != undefined &&
            number != "0.00" &&
            number != null &&
            number != ""
        ) {


            var str2 = (number.toString()).replace(/\,/g, "");
            var str3 = str2.replace(SymbolofCurrency, "");
            if (existingCurrency)
                var str3 = str3.replace(existingCurrency, "");
            var str3 = str3.replace(cSymbol, "");
            if (str3 != undefined && str3 != NaN) number = str3;


            var decimalcharacter = ".";

            var thousandseparater = ",";
            if (IsThousandseparater == false)
                thousandseparater = "";
            else
                thousandseparater = ",";

            number = parseFloat(number);
            var sign = number < 0 ? "-" : "";

            var formatted = new String(number.toFixed(decimalplaces));
            if (decimalcharacter.length && decimalcharacter != ".") {
                formatted = formatted.replace(/\./, decimalcharacter);
            }
            var integer = "";
            var fraction = "";
            var strnumber = new String(formatted);
            var dotpos = decimalcharacter.length ?
                strnumber.indexOf(decimalcharacter) :
                -1;
            if (dotpos > -1) {
                if (dotpos) {
                    integer = strnumber.substr(0, dotpos);
                }
                fraction = strnumber.substr(dotpos + 1);
            } else {
                integer = strnumber;
            }
            if (integer) {
                integer = String(Math.abs(integer));
            }
            while (fraction.length < decimalplaces) {
                fraction += "0";
            }
            temparray = new Array();
            while (integer.length > 3) {
                temparray.unshift(integer.substr(-3));
                integer = integer.substr(0, integer.length - 3);
            }
            temparray.unshift(integer);
            integer = temparray.join(thousandseparater);



            if (Num < 0) {
                if (CurrencySysmbolOnRight == true)
                    finalCurrencyObj = "(" + integer + decimalcharacter + fraction + " " + CurrencySign + ")";
                else
                    finalCurrencyObj = "(" + CurrencySign + integer + decimalcharacter + fraction + ")";
            } else {
                if (CurrencySysmbolOnRight == true)
                    finalCurrencyObj =
                    integer + decimalcharacter + fraction + " " + CurrencySign;
                else
                    finalCurrencyObj =
                    CurrencySign + integer + decimalcharacter + fraction;
            }

            return finalCurrencyObj;
        } else {
            if (CurrencySysmbolOnRight == true)
                return "0.00 " + CurrencySign;
            else
                return CurrencySign + " 0.00";
        }
    },

    TransactionCurrencyFormat: function(number) {
        //var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var cSymbol ="₹";
        var decimalplaces = 2;
        var CurrencySysmbolOnRight = false;
        var IsThousandseparater = true;

        var transactionCurrencySymbol = this.GetSession("TransactionCurrencySymbol");
        var currencyforGrid = this.GetSession("TransactionCurrencyCode");
        var SymbolofCurrency = null;

        if (transactionCurrencySymbol != "null" && transactionCurrencySymbol != undefined && transactionCurrencySymbol != null)
            SymbolofCurrency = transactionCurrencySymbol;
        else if (cSymbol != null)
            SymbolofCurrency = cSymbol;
        else
            SymbolofCurrency = "";


        var CurrencySign = SymbolofCurrency + " ";

        if (number == undefined || number == null || number == '.' || number == "")
            number = 0.00;

        var Num = number;
        var finalCurrencyObj = null;
        if (number != undefined) {
            var decimalcharacter = ".";

            var thousandseparater = ",";
            if (IsThousandseparater == false)
                thousandseparater = "";
            else
                thousandseparater = ",";

            number = parseFloat(number);
            var sign = number < 0 ? "-" : "";

            var formatted = new String(number.toFixed(decimalplaces));
            if (decimalcharacter.length && decimalcharacter != ".") {
                formatted = formatted.replace(/\./, decimalcharacter);
            }
            var integer = "";
            var fraction = "";
            var strnumber = new String(formatted);
            var dotpos = decimalcharacter.length ?
                strnumber.indexOf(decimalcharacter) :
                -1;
            if (dotpos > -1) {
                if (dotpos) {
                    integer = strnumber.substr(0, dotpos);
                }
                fraction = strnumber.substr(dotpos + 1);
            } else {
                integer = strnumber;
            }
            if (integer) {
                integer = String(Math.abs(integer));
            }
            while (fraction.length < decimalplaces) {
                fraction += "0";
            }
            var temparray = new Array();
            while (integer.length > 3) {
                temparray.unshift(integer.substr(-3));
                integer = integer.substr(0, integer.length - 3);
            }
            temparray.unshift(integer);
            integer = temparray.join(thousandseparater);
            if (Num < 0) {
                if (CurrencySysmbolOnRight == true)
                    finalCurrencyObj = "(" + integer + decimalcharacter + fraction + " " + CurrencySign + ")";
                else
                    finalCurrencyObj = "(" + CurrencySign + integer + decimalcharacter + fraction + ")";
            } else {
                if (CurrencySysmbolOnRight == true)
                    finalCurrencyObj =
                    integer + decimalcharacter + fraction + " " + CurrencySign;
                else
                    finalCurrencyObj =
                    CurrencySign + integer + decimalcharacter + fraction;
            }
            return finalCurrencyObj;
        } else {
            if (CurrencySysmbolOnRight == true)
                return "0.00 " + CurrencySign;
            else
                return CurrencySign + " 0.00";
        }
    },


    PDFCurrencyFormat: function(number, existingCurrency) {
        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var cSymbol = AppData.BaseCurrency.Symbol;
        var decimalplaces = AppData.DecimalPoint;
        var CurrencySysmbolOnRight = AppData.IsCurrencySymbolOnRight;
        var IsThousandseparater = AppData.IsThousandSeperatorRequired;

        var transactionCurrencySymbol = $window.sessionStorage.getItem("transactionCurrencySymbol");
        var SymbolofCurrency = null;
        var currencyforGrid = $window.sessionStorage.getItem("transactionCurrencyCode");
        if (transactionCurrencySymbol != "null" && transactionCurrencySymbol != undefined && transactionCurrencySymbol != null)
            SymbolofCurrency = transactionCurrencySymbol;
        else if (cSymbol != null && CustomerCurrencyCode != currencyforGrid)
            SymbolofCurrency = cSymbol;
        else
            SymbolofCurrency = "";
        var CurrencySign = SymbolofCurrency + " ";
        if (number != undefined && number != null && number == '.')
            number = 0.00;
        var Num = number;
        var finalCurrencyObj = null;
        var temp = number;

        // for temporary use
        CurrencySign = "";


        if (
            number != undefined &&
            number != "0.00" &&
            number != null &&
            number != ""
        ) {


            var str2 = (number.toString()).replace(/\,/g, "");
            var str3 = str2.replace(SymbolofCurrency, "");
            if (existingCurrency)
                var str3 = str3.replace(existingCurrency, "");
            var str3 = str3.replace(cSymbol, "");
            if (str3 != undefined && str3 != NaN) number = str3;


            var decimalcharacter = ".";

            var thousandseparater = ",";
            if (IsThousandseparater == false)
                thousandseparater = "";
            else
                thousandseparater = ",";

            number = parseFloat(number);
            var sign = number < 0 ? "-" : "";

            var formatted = new String(number.toFixed(decimalplaces));
            if (decimalcharacter.length && decimalcharacter != ".") {
                formatted = formatted.replace(/\./, decimalcharacter);
            }
            var integer = "";
            var fraction = "";
            var strnumber = new String(formatted);
            var dotpos = decimalcharacter.length ?
                strnumber.indexOf(decimalcharacter) :
                -1;
            if (dotpos > -1) {
                if (dotpos) {
                    integer = strnumber.substr(0, dotpos);
                }
                fraction = strnumber.substr(dotpos + 1);
            } else {
                integer = strnumber;
            }
            if (integer) {
                integer = String(Math.abs(integer));
            }
            while (fraction.length < decimalplaces) {
                fraction += "0";
            }
            temparray = new Array();
            while (integer.length > 3) {
                temparray.unshift(integer.substr(-3));
                integer = integer.substr(0, integer.length - 3);
            }
            temparray.unshift(integer);
            integer = temparray.join(thousandseparater);



            if (Num < 0) {
                if (CurrencySysmbolOnRight == true)
                    finalCurrencyObj = "(" + integer + decimalcharacter + fraction + " " + CurrencySign + ")";
                else
                    finalCurrencyObj = "(" + CurrencySign + integer + decimalcharacter + fraction + ")";
            } else {
                if (CurrencySysmbolOnRight == true)
                    finalCurrencyObj =
                    integer + decimalcharacter + fraction + " " + CurrencySign;
                else
                    finalCurrencyObj =
                    CurrencySign + integer + decimalcharacter + fraction;
            }

            return finalCurrencyObj;
        } else {
            if (CurrencySysmbolOnRight == true)
                return "0.00 " + CurrencySign;
            else
                return CurrencySign + " 0.00";
        }
    },


    CurrencyFormatText: function(number) {

        var decimalplaces = 2;
        var CurrencySysmbolOnRight = true;
        var IsThousandseparater = true;

        if (number != undefined && number != null && number == '.')
            number = 0.00;
        var Num = number;
        var finalCurrencyObj = null;
        var temp = number;


        if (
            number != undefined &&
            number != "0.00" &&
            number != null &&
            number != ""
        ) {

            var str2 = (number.toString()).replace(/\,/g, "");
            if (str2 != undefined && str2 != NaN) number = str2;


            var decimalcharacter = ".";
            var thousandseparater = ",";
            number = parseFloat(number);
            var sign = number < 0 ? "-" : "";

            var formatted = new String(number.toFixed(decimalplaces));
            if (decimalcharacter.length && decimalcharacter != ".") {
                formatted = formatted.replace(/\./, decimalcharacter);
            }
            var integer = "";
            var fraction = "";
            var strnumber = new String(formatted);
            var dotpos = decimalcharacter.length ?
                strnumber.indexOf(decimalcharacter) :
                -1;
            if (dotpos > -1) {
                if (dotpos) {
                    integer = strnumber.substr(0, dotpos);
                }
                fraction = strnumber.substr(dotpos + 1);
            } else {
                integer = strnumber;
            }
            if (integer) {
                integer = String(Math.abs(integer));
            }
            while (fraction.length < decimalplaces) {
                fraction += "0";
            }
            var temparray = new Array();
            while (integer.length > 3) {
                temparray.unshift(integer.substr(-3));
                integer = integer.substr(0, integer.length - 3);
            }
            temparray.unshift(integer);
            integer = temparray.join(thousandseparater);

            if (Num < 0)
                finalCurrencyObj = "(" + integer + decimalcharacter + fraction + ")";


            else finalCurrencyObj = integer + decimalcharacter + fraction;


            return finalCurrencyObj;
        } else {
            return "0.00";
        }
    },

    // Application Configuration MethodOfRounding
    MethodOfRounding: function(num) {
        var Data = JSON.parse($window.sessionStorage.getItem("AppCofigData"));
        var roundid = Data.MethodOfRounding.Id;
        var Result = num;
        var decpoint = Data.DecimalPoint;

        if (Result != undefined) {
            if (
                Data != null &&
                Data != undefined &&
                num != null &&
                num != undefined
            ) {
                if (roundid > 0) {
                    if (roundid === 2) {
                        Result = Math.round(num * 500) / 500;
                    } else if (roundid === 3) {
                        Result = Math.round(num * 1000) / 1000;
                    } else if (roundid === 5) {
                        Result = Math.round(num / 10) * 10;
                    } else if (roundid === 4) {
                        Result = Math.round(num);
                    }
                } else {
                    Result = num;
                }

                if (decpoint > 0) {
                    Result = parseFloat(Result).toFixed(decpoint);
                } else {
                    Result = parseFloat(Result).toFixed(2);
                }
            } else {
                Result = parseFloat(Result).toFixed(2);
            }

            if (Result == "NaN") {
                Result = null;
            }
        } else {
            Item = null;
        }

        return Result;
    },

    // Application Configuration Currency Symbol On Right Function
    CurrencySymbolOnRight: function(Currency) {
        var Data = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var IsRightSide = Data.IsCurrencySymbolOnRight;

        var IsSymbol = Currency.substr(Currency.length - 1);

        if (isNaN("IsSymbol")) {}

        if (IsRightSide) {
            Currency = Currency + " " + Data.BaseCurrency.Symbol;
        } else {
            Currency = Data.BaseCurrency.Symbol + " " + Currency;
        }

        return Currency;
    },

    CurrencyCode: function() {
        var Currency;
        var Data = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        Currency = Data.BaseCurrency.Code;
        return Currency;
    },

    /// Filter grid by date range
    filterGridByDateRange: function(gridData, dateRange, columnName) {
        var result = [];
        var date1 = this.getDateOnly(dateRange[0]);
        var date2 = this.getDateOnly(dateRange[1]);
        if (gridData && columnName) {
            if ((dateRange[0] && dateRange[1]) || dateRange) {
                angular.forEach(gridData, function(value, key) {
                    angular.forEach(value, function(subValue, subKey) {
                        if (subKey === columnName) {
                            var ColumnDate = new Date(subValue);
                            var date = new Date(
                                ColumnDate.getFullYear(),
                                ColumnDate.getMonth(),
                                ColumnDate.getDate()
                            );
                            if (date >= date1 && date <= date2) {
                                result.push(gridData[key]);
                            }
                        }
                    });
                });
            }
        }
        return result;
    },
    ///Code by arun for filter grid data by amount and list of names
    ///Get filter By Amount range and particular column
    filterGridByRange: function(gridData, Range, columnName) {
        var result = [];
        if (gridData && columnName) {
            if ((Range[0] && Range[1]) || Range) {
                var Range1 = parseFloat(Range[0]);
                Range2 = parseFloat(Range[1]);
                angular.forEach(gridData, function(value, key) {
                    angular.forEach(value, function(subValue, subKey) {
                        if (subKey === columnName) {
                            if (subValue >= Range1 && subValue <= Range2) {
                                result.push(gridData[key]);
                            }
                        }
                    });
                });
            }
        }
        return result;
    },

    ///Get filter By List of names and particular column
    filterGridByNameList: function(gridData, Names, columnName) {
        var result = [];
        if (gridData && columnName) {
            if (Names) {
                angular.forEach(gridData, function(value, key) {
                    angular.forEach(value, function(subValue, subKey) {
                        if (subKey === columnName) {
                            for (var i = 0; i < Names.length; i++) {
                                if (subValue === Names[i].Name) {
                                    result.push(gridData[key]);
                                }
                            }
                        }
                    });
                });
            }
        }
        return result;
    },

    commaseperator: function(value) {
        data = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return data;
    },

    ///End code for filter amount and string

    getDateOnly: function(datetime) {
        var dateNeeded = datetime.getFullYear();
        var date = new Date(
            datetime.getFullYear(),
            datetime.getMonth(),
            datetime.getDate()
        );
        return date;
    },

    //Get past 7 days date range
    getPastSevenDays: function() {
        var today = new Date();
        var sevenDaysAgo = new Date().setDate(today.getDate() - 7);

        return sevenDaysAgo;
    },

    SetTime(date) {
        if (this.IsNotNullOrEmptyOrUndefined(date)) {
            date = new Date(date)
            date.setHours(new Date().getHours());
            date.setMinutes(new Date().getMinutes());
            date.setSeconds(new Date().getSeconds());
            return date;
        }
    },

    // get Current weeks date range
    getThisWeek: function() {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first + 6;
        var firstday = new Date(curr.setDate(first)); //.toUTCString();
        var lastday = new Date(curr.setDate(last)); //.toUTCString();
        return [firstday, lastday];
    },

    // Get current month date range
    getThisMonth: function() {
        var date = new Date();
        var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
        var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return [StartDate, EndDate];
    },

    DifferenceDate: function(sdate, tdate) {
        if (sdate != null && tdate != null)
            return parseInt((tdate - sdate) / (1000 * 60 * 60 * 24), 10) + 1;
    },


    getDateFormatWithEmptyTime: function(d) {
        d = new Date(d);
        d = d
            .toISOString()
            .substr(0, 19)
            .replace("T", " ");
        return d;
    },

    CheckforNull: function(inputvalue) {
        if (inputvalue == undefined || inputvalue == null || inputvalue == "null")
            inputvalue = '';
        return inputvalue;
    },

    PdfDocMasterLayout: function() {
        var Layout = {
            hLineWidth: function(i, node) {
                return 0.5;
            },
            vLineWidth: function(i, node) {
                return 0.5;
            },
            vLineColor: function(i, node) {
                return 'gray';
            },
            hLineColor: function(i, node) {
                return 'gray';
            }
        }
        return Layout

    },

    PdfGridBorderLayout: function() {
        var Layout = {
            hLineWidth: function(i, node) {
                return 0.5;
            },
            vLineWidth: function(i, node) {
                return 0.5;
            },
            vLineColor: function(i, node) {
                return 'gray';
            },
            hLineColor: function(i, node) {
                //return 'gray';
                return (i === 0 || i == node.table.body.length || (node.table.body.length == 0 || i == 1)) ? 'gray' : 'white';
            }

        }

        return Layout

    },

    PdfGridJobcardBorderLayout: function() {
        var Layout = {
            hLineWidth: function(i, node) {
                return 0.5;
            },
            vLineWidth: function(i, node) {
                return 0.5;
            },
            vLineColor: function(i, node) {
                return 'gray';
            },
            hLineColor: function(i, node) {
                return 'gray';
            }

        }
        return Layout
    },

    pageNumberReplace: function(currentPage, pageCount) {

        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var Format = (AppData.PageNumberFormat.Format != null || AppData.PageNumberFormat.Format != undefined) ? AppData.PageNumberFormat.Format : '';

        var str = Format;
        str = str.toString();
        if (str == 'Page x of y') {
            var result = str.replace(/x/, currentPage);
            result = result.replace(/y/, pageCount);
        } else if (str == 'none' || str == '') {
            result = '';
        } else {
            var result = str.replace(/NO/, currentPage);
        }
        return result
    },

    FinanceAttachmentDownload: function(row) {
        //fileDownload: function (data, strFileName, strMimeType) {
        var selectedData = null;
        var SessionData = JSON.parse($window.sessionStorage.getItem("SessionData"));

        if (row.entity.ID != undefined && row.entity.ID != 0) {
            CRUDAttachment.GetFinanceAttachmentbyID(SessionData.AuthToken, SessionData.SessionID, row.entity.ID).then(function(response) {
                    //Utility.SessionTimeout($scope.WareHouseReceiptBO.TransactionAdd);
                    //$scope.WareHouseReceiptBO.TransactionAdd.PageLoadStatus = 'none';
                    if (response.data.ErrorInfo.ErrorMessage == null) {
                        selectedData = response.data.result;
                        data = selectedData.Attachment;
                        strFileName = row.entity.FileName;
                        strMimeType = row.entity.FileType;


                        var self = window, // this script is only for browsers anyway...
                            defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
                            mimeType = strMimeType || defaultMime,
                            payload = data,
                            url = !strFileName && !strMimeType && payload,
                            anchor = document.createElement("a"),
                            toString = function(a) {
                                return String(a);
                            },
                            myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
                            fileName = strFileName || "download",
                            blob,
                            reader;
                        myBlob = myBlob.call ? myBlob.bind(self) : Blob;

                        if (String(this) === "true") { //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
                            payload = [payload, mimeType];
                            mimeType = payload[0];
                            payload = payload[1];
                        }


                        if (url && url.length < 2048) { // if no filename and no mime, assume a url was passed as the only argument
                            fileName = url.split("/").pop().split("?")[0];
                            anchor.href = url; // assign href prop to temp anchor
                            if (anchor.href.indexOf(url) !== -1) { // if the browser determines that it's a potentially valid url path:
                                var ajax = new XMLHttpRequest();
                                ajax.open("GET", url, true);
                                ajax.responseType = 'blob';
                                ajax.onload = function(e) {
                                    download(e.target.response, fileName, defaultMime);
                                };
                                setTimeout(function() {
                                    ajax.send();
                                }, 0); // allows setting custom ajax headers using the return:
                                return ajax;
                            } // end if valid url?
                        } // end if url?


                        //go ahead and download dataURLs right away
                        if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {

                            if (payload.length > (1024 * 1024 * 1.999) && myBlob !== toString) {
                                payload = dataUrlToBlob(payload);
                                mimeType = payload.type || defaultMime;
                            } else {
                                return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
                                    navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
                                    saver(payload); // everyone else can save dataURLs un-processed
                            }

                        } //end if dataURL passed?

                        blob = payload instanceof myBlob ?
                            payload :
                            new myBlob([payload], {
                                type: mimeType
                            });


                        function dataUrlToBlob(strUrl) {
                            var parts = strUrl.split(/[:;,]/),
                                type = parts[1],
                                decoder = parts[2] == "base64" ? atob : decodeURIComponent,
                                binData = decoder(parts.pop()),
                                mx = binData.length,
                                i = 0,
                                uiArr = new Uint8Array(mx);

                            for (i; i < mx; ++i) uiArr[i] = binData.charCodeAt(i);

                            return new myBlob([uiArr], {
                                type: type
                            });
                        }

                        function saver(url, winMode) {

                            if ('download' in anchor) { //html5 A[download]
                                anchor.href = url;
                                anchor.setAttribute("download", fileName);
                                anchor.className = "download-js-link";
                                anchor.innerHTML = "downloading...";
                                anchor.style.display = "none";
                                document.body.appendChild(anchor);
                                setTimeout(function() {
                                    anchor.click();
                                    document.body.removeChild(anchor);
                                    if (winMode === true) {
                                        setTimeout(function() {
                                            self.URL.revokeObjectURL(anchor.href);
                                        }, 250);
                                    }
                                }, 66);
                                return true;
                            }

                            // handle non-a[download] safari as best we can:
                            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                                url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                                if (!window.open(url)) { // popup blocked, offer direct download:
                                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
                                        location.href = url;
                                    }
                                }
                                return true;
                            }

                            //do iframe dataURL download (old ch+FF):
                            var f = document.createElement("iframe");
                            document.body.appendChild(f);

                            if (!winMode) { // force a mime that will download:
                                url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                            }
                            f.src = url;
                            setTimeout(function() {
                                document.body.removeChild(f);
                            }, 333);

                        } //end saver




                        if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
                            return navigator.msSaveBlob(blob, fileName);
                        }

                        if (self.URL) { // simple fast and modern way using Blob and URL:
                            saver(self.URL.createObjectURL(blob), true);
                        } else {
                            // handle non-Blob()+non-URL browsers:
                            if (typeof blob === "string" || blob.constructor === toString) {
                                try {
                                    return saver("data:" + mimeType + ";base64," + self.btoa(blob));
                                } catch (y) {
                                    return saver("data:" + mimeType + "," + encodeURIComponent(blob));
                                }
                            }

                            // Blob but not URL support:
                            reader = new FileReader();
                            reader.onload = function(e) {
                                saver(this.result);
                            };
                            reader.readAsDataURL(blob);
                        }
                        return true;


                    }
                },
                function errorcallback(response) {
                    // Utility.ServiceErrorCallback(response, $scope.WareHouseReceiptBO.TransactionAdd);
                    toaster.error("Acction Failed", "now only attached this");
                });
        } else {
            toaster.pop("warning", "now only attached this");
        }




    },

    PurchaseAttachmentDownload: function(row) {
        //fileDownload: function (data, strFileName, strMimeType) {
        var selectedData = null;
        var SessionData = JSON.parse($window.sessionStorage.getItem("SessionData"));

        if (row.entity.ID != undefined && row.entity.ID != 0) {
            CRUDAttachment.GetPurchaseAttachmentbyID(SessionData.AuthToken, SessionData.SessionID, row.entity.ID).then(function(response) {
                    //Utility.SessionTimeout($scope.WareHouseReceiptBO.TransactionAdd);
                    //$scope.WareHouseReceiptBO.TransactionAdd.PageLoadStatus = 'none';
                    if (response.data.ErrorInfo.ErrorMessage == null) {
                        selectedData = response.data.result;
                        data = selectedData.Attachment;
                        strFileName = row.entity.FileName;
                        strMimeType = row.entity.FileType;


                        var self = window, // this script is only for browsers anyway...
                            defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
                            mimeType = strMimeType || defaultMime,
                            payload = data,
                            url = !strFileName && !strMimeType && payload,
                            anchor = document.createElement("a"),
                            toString = function(a) {
                                return String(a);
                            },
                            myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
                            fileName = strFileName || "download",
                            blob,
                            reader;
                        myBlob = myBlob.call ? myBlob.bind(self) : Blob;

                        if (String(this) === "true") { //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
                            payload = [payload, mimeType];
                            mimeType = payload[0];
                            payload = payload[1];
                        }


                        if (url && url.length < 2048) { // if no filename and no mime, assume a url was passed as the only argument
                            fileName = url.split("/").pop().split("?")[0];
                            anchor.href = url; // assign href prop to temp anchor
                            if (anchor.href.indexOf(url) !== -1) { // if the browser determines that it's a potentially valid url path:
                                var ajax = new XMLHttpRequest();
                                ajax.open("GET", url, true);
                                ajax.responseType = 'blob';
                                ajax.onload = function(e) {
                                    download(e.target.response, fileName, defaultMime);
                                };
                                setTimeout(function() {
                                    ajax.send();
                                }, 0); // allows setting custom ajax headers using the return:
                                return ajax;
                            } // end if valid url?
                        } // end if url?


                        //go ahead and download dataURLs right away
                        if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {

                            if (payload.length > (1024 * 1024 * 1.999) && myBlob !== toString) {
                                payload = dataUrlToBlob(payload);
                                mimeType = payload.type || defaultMime;
                            } else {
                                return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
                                    navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
                                    saver(payload); // everyone else can save dataURLs un-processed
                            }

                        } //end if dataURL passed?

                        blob = payload instanceof myBlob ?
                            payload :
                            new myBlob([payload], {
                                type: mimeType
                            });


                        function dataUrlToBlob(strUrl) {
                            var parts = strUrl.split(/[:;,]/),
                                type = parts[1],
                                decoder = parts[2] == "base64" ? atob : decodeURIComponent,
                                binData = decoder(parts.pop()),
                                mx = binData.length,
                                i = 0,
                                uiArr = new Uint8Array(mx);

                            for (i; i < mx; ++i) uiArr[i] = binData.charCodeAt(i);

                            return new myBlob([uiArr], {
                                type: type
                            });
                        }

                        function saver(url, winMode) {

                            if ('download' in anchor) { //html5 A[download]
                                anchor.href = url;
                                anchor.setAttribute("download", fileName);
                                anchor.className = "download-js-link";
                                anchor.innerHTML = "downloading...";
                                anchor.style.display = "none";
                                document.body.appendChild(anchor);
                                setTimeout(function() {
                                    anchor.click();
                                    document.body.removeChild(anchor);
                                    if (winMode === true) {
                                        setTimeout(function() {
                                            self.URL.revokeObjectURL(anchor.href);
                                        }, 250);
                                    }
                                }, 66);
                                return true;
                            }

                            // handle non-a[download] safari as best we can:
                            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                                url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                                if (!window.open(url)) { // popup blocked, offer direct download:
                                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
                                        location.href = url;
                                    }
                                }
                                return true;
                            }

                            //do iframe dataURL download (old ch+FF):
                            var f = document.createElement("iframe");
                            document.body.appendChild(f);

                            if (!winMode) { // force a mime that will download:
                                url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                            }
                            f.src = url;
                            setTimeout(function() {
                                document.body.removeChild(f);
                            }, 333);

                        } //end saver




                        if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
                            return navigator.msSaveBlob(blob, fileName);
                        }

                        if (self.URL) { // simple fast and modern way using Blob and URL:
                            saver(self.URL.createObjectURL(blob), true);
                        } else {
                            // handle non-Blob()+non-URL browsers:
                            if (typeof blob === "string" || blob.constructor === toString) {
                                try {
                                    return saver("data:" + mimeType + ";base64," + self.btoa(blob));
                                } catch (y) {
                                    return saver("data:" + mimeType + "," + encodeURIComponent(blob));
                                }
                            }

                            // Blob but not URL support:
                            reader = new FileReader();
                            reader.onload = function(e) {
                                saver(this.result);
                            };
                            reader.readAsDataURL(blob);
                        }
                        return true;
                    }

                },
                function errorcallback(response) {
                    // Utility.ServiceErrorCallback(response, $scope.WareHouseReceiptBO.TransactionAdd);
                    toaster.error("Acction Failed", "now only attached this");
                });
        } else {
            toaster.pop("warning", "now only attached this");
        }




    },

    InventoryAttachmentDownload: function(row) {
        //fileDownload: function (data, strFileName, strMimeType) {
        var selectedData = null;
        var SessionData = JSON.parse($window.sessionStorage.getItem("SessionData"));

        if (row.entity.ID != undefined && row.entity.ID != 0) {
            CRUDAttachment.GetInventoryAttachmentbyID(SessionData.AuthToken, SessionData.SessionID, row.entity.ID).then(function(response) {
                    //Utility.SessionTimeout($scope.WareHouseReceiptBO.TransactionAdd);
                    //$scope.WareHouseReceiptBO.TransactionAdd.PageLoadStatus = 'none';
                    if (response.data.ErrorInfo.ErrorMessage == null) {
                        selectedData = response.data.result;
                        data = selectedData.Attachment;
                        strFileName = row.entity.FileName;
                        strMimeType = row.entity.FileType;


                        var self = window, // this script is only for browsers anyway...
                            defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
                            mimeType = strMimeType || defaultMime,
                            payload = data,
                            url = !strFileName && !strMimeType && payload,
                            anchor = document.createElement("a"),
                            toString = function(a) {
                                return String(a);
                            },
                            myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
                            fileName = strFileName || "download",
                            blob,
                            reader;
                        myBlob = myBlob.call ? myBlob.bind(self) : Blob;

                        if (String(this) === "true") { //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
                            payload = [payload, mimeType];
                            mimeType = payload[0];
                            payload = payload[1];
                        }


                        if (url && url.length < 2048) { // if no filename and no mime, assume a url was passed as the only argument
                            fileName = url.split("/").pop().split("?")[0];
                            anchor.href = url; // assign href prop to temp anchor
                            if (anchor.href.indexOf(url) !== -1) { // if the browser determines that it's a potentially valid url path:
                                var ajax = new XMLHttpRequest();
                                ajax.open("GET", url, true);
                                ajax.responseType = 'blob';
                                ajax.onload = function(e) {
                                    download(e.target.response, fileName, defaultMime);
                                };
                                setTimeout(function() {
                                    ajax.send();
                                }, 0); // allows setting custom ajax headers using the return:
                                return ajax;
                            } // end if valid url?
                        } // end if url?


                        //go ahead and download dataURLs right away
                        if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {

                            if (payload.length > (1024 * 1024 * 1.999) && myBlob !== toString) {
                                payload = dataUrlToBlob(payload);
                                mimeType = payload.type || defaultMime;
                            } else {
                                return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
                                    navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
                                    saver(payload); // everyone else can save dataURLs un-processed
                            }

                        } //end if dataURL passed?

                        blob = payload instanceof myBlob ?
                            payload :
                            new myBlob([payload], {
                                type: mimeType
                            });


                        function dataUrlToBlob(strUrl) {
                            var parts = strUrl.split(/[:;,]/),
                                type = parts[1],
                                decoder = parts[2] == "base64" ? atob : decodeURIComponent,
                                binData = decoder(parts.pop()),
                                mx = binData.length,
                                i = 0,
                                uiArr = new Uint8Array(mx);

                            for (i; i < mx; ++i) uiArr[i] = binData.charCodeAt(i);

                            return new myBlob([uiArr], {
                                type: type
                            });
                        }

                        function saver(url, winMode) {

                            if ('download' in anchor) { //html5 A[download]
                                anchor.href = url;
                                anchor.setAttribute("download", fileName);
                                anchor.className = "download-js-link";
                                anchor.innerHTML = "downloading...";
                                anchor.style.display = "none";
                                document.body.appendChild(anchor);
                                setTimeout(function() {
                                    anchor.click();
                                    document.body.removeChild(anchor);
                                    if (winMode === true) {
                                        setTimeout(function() {
                                            self.URL.revokeObjectURL(anchor.href);
                                        }, 250);
                                    }
                                }, 66);
                                return true;
                            }

                            // handle non-a[download] safari as best we can:
                            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                                url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                                if (!window.open(url)) { // popup blocked, offer direct download:
                                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
                                        location.href = url;
                                    }
                                }
                                return true;
                            }

                            //do iframe dataURL download (old ch+FF):
                            var f = document.createElement("iframe");
                            document.body.appendChild(f);

                            if (!winMode) { // force a mime that will download:
                                url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                            }
                            f.src = url;
                            setTimeout(function() {
                                document.body.removeChild(f);
                            }, 333);

                        } //end saver




                        if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
                            return navigator.msSaveBlob(blob, fileName);
                        }

                        if (self.URL) { // simple fast and modern way using Blob and URL:
                            saver(self.URL.createObjectURL(blob), true);
                        } else {
                            // handle non-Blob()+non-URL browsers:
                            if (typeof blob === "string" || blob.constructor === toString) {
                                try {
                                    return saver("data:" + mimeType + ";base64," + self.btoa(blob));
                                } catch (y) {
                                    return saver("data:" + mimeType + "," + encodeURIComponent(blob));
                                }
                            }

                            // Blob but not URL support:
                            reader = new FileReader();
                            reader.onload = function(e) {
                                saver(this.result);
                            };
                            reader.readAsDataURL(blob);
                        }
                        return true;


                    }
                },
                function errorcallback(response) {
                    // Utility.ServiceErrorCallback(response, $scope.WareHouseReceiptBO.TransactionAdd);
                    toaster.error("Acction Failed", "now only attached this");
                });
        } else {
            toaster.pop("warning", "now only attached this");
        }




    },

    HRMAttachmentDownload: function(row) {
        //fileDownload: function (data, strFileName, strMimeType) {
        var selectedData = null;
        var SessionData = JSON.parse($window.sessionStorage.getItem("SessionData"));

        if (row.entity.ID != undefined && row.entity.ID != 0) {
            CRUDAttachment.GetHRMAttachmentbyID(SessionData.AuthToken, SessionData.SessionID, row.entity.ID).then(function(response) {
                    //Utility.SessionTimeout($scope.WareHouseReceiptBO.TransactionAdd);
                    //$scope.WareHouseReceiptBO.TransactionAdd.PageLoadStatus = 'none';
                    if (response.data.ErrorInfo.ErrorMessage == null) {
                        selectedData = response.data.result;
                        data = selectedData.Attachment;
                        strFileName = row.entity.FileName;
                        strMimeType = row.entity.FileType;


                        var self = window, // this script is only for browsers anyway...
                            defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
                            mimeType = strMimeType || defaultMime,
                            payload = data,
                            url = !strFileName && !strMimeType && payload,
                            anchor = document.createElement("a"),
                            toString = function(a) {
                                return String(a);
                            },
                            myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
                            fileName = strFileName || "download",
                            blob,
                            reader;
                        myBlob = myBlob.call ? myBlob.bind(self) : Blob;

                        if (String(this) === "true") { //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
                            payload = [payload, mimeType];
                            mimeType = payload[0];
                            payload = payload[1];
                        }


                        if (url && url.length < 2048) { // if no filename and no mime, assume a url was passed as the only argument
                            fileName = url.split("/").pop().split("?")[0];
                            anchor.href = url; // assign href prop to temp anchor
                            if (anchor.href.indexOf(url) !== -1) { // if the browser determines that it's a potentially valid url path:
                                var ajax = new XMLHttpRequest();
                                ajax.open("GET", url, true);
                                ajax.responseType = 'blob';
                                ajax.onload = function(e) {
                                    download(e.target.response, fileName, defaultMime);
                                };
                                setTimeout(function() {
                                    ajax.send();
                                }, 0); // allows setting custom ajax headers using the return:
                                return ajax;
                            } // end if valid url?
                        } // end if url?


                        //go ahead and download dataURLs right away
                        if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {

                            if (payload.length > (1024 * 1024 * 1.999) && myBlob !== toString) {
                                payload = dataUrlToBlob(payload);
                                mimeType = payload.type || defaultMime;
                            } else {
                                return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
                                    navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
                                    saver(payload); // everyone else can save dataURLs un-processed
                            }

                        } //end if dataURL passed?

                        blob = payload instanceof myBlob ?
                            payload :
                            new myBlob([payload], {
                                type: mimeType
                            });


                        function dataUrlToBlob(strUrl) {
                            var parts = strUrl.split(/[:;,]/),
                                type = parts[1],
                                decoder = parts[2] == "base64" ? atob : decodeURIComponent,
                                binData = decoder(parts.pop()),
                                mx = binData.length,
                                i = 0,
                                uiArr = new Uint8Array(mx);

                            for (i; i < mx; ++i) uiArr[i] = binData.charCodeAt(i);

                            return new myBlob([uiArr], {
                                type: type
                            });
                        }

                        function saver(url, winMode) {

                            if ('download' in anchor) { //html5 A[download]
                                anchor.href = url;
                                anchor.setAttribute("download", fileName);
                                anchor.className = "download-js-link";
                                anchor.innerHTML = "downloading...";
                                anchor.style.display = "none";
                                document.body.appendChild(anchor);
                                setTimeout(function() {
                                    anchor.click();
                                    document.body.removeChild(anchor);
                                    if (winMode === true) {
                                        setTimeout(function() {
                                            self.URL.revokeObjectURL(anchor.href);
                                        }, 250);
                                    }
                                }, 66);
                                return true;
                            }

                            // handle non-a[download] safari as best we can:
                            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                                url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                                if (!window.open(url)) { // popup blocked, offer direct download:
                                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
                                        location.href = url;
                                    }
                                }
                                return true;
                            }

                            //do iframe dataURL download (old ch+FF):
                            var f = document.createElement("iframe");
                            document.body.appendChild(f);

                            if (!winMode) { // force a mime that will download:
                                url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                            }
                            f.src = url;
                            setTimeout(function() {
                                document.body.removeChild(f);
                            }, 333);

                        } //end saver




                        if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
                            return navigator.msSaveBlob(blob, fileName);
                        }

                        if (self.URL) { // simple fast and modern way using Blob and URL:
                            saver(self.URL.createObjectURL(blob), true);
                        } else {
                            // handle non-Blob()+non-URL browsers:
                            if (typeof blob === "string" || blob.constructor === toString) {
                                try {
                                    return saver("data:" + mimeType + ";base64," + self.btoa(blob));
                                } catch (y) {
                                    return saver("data:" + mimeType + "," + encodeURIComponent(blob));
                                }
                            }

                            // Blob but not URL support:
                            reader = new FileReader();
                            reader.onload = function(e) {
                                saver(this.result);
                            };
                            reader.readAsDataURL(blob);
                        }
                        return true;
                    }

                },
                function errorcallback(response) {
                    // Utility.ServiceErrorCallback(response, $scope.WareHouseReceiptBO.TransactionAdd);
                    toaster.error("Acction Failed", "now only attached this");
                });
        } else {
            toaster.pop("warning", "now only attached this");
        }




    },

    fileDownload: function(row) {
        //fileDownload: function (data, strFileName, strMimeType) {
        var selectedData = null;
        var SessionData = JSON.parse($window.sessionStorage.getItem("SessionData"));

        if (row.entity.ID != undefined && row.entity.ID != 0) {
            CRUDAttachment.GetServiceAttachmentbyID(SessionData.AuthToken, SessionData.SessionID, row.entity.ID).then(function(response) {
                    //Utility.SessionTimeout($scope.WareHouseReceiptBO.TransactionAdd);
                    //$scope.WareHouseReceiptBO.TransactionAdd.PageLoadStatus = 'none';
                    if (response.data.ErrorInfo.ErrorMessage == null) {
                        selectedData = response.data.result;
                        data = selectedData.Attachment;
                        strFileName = row.entity.FileName;
                        strMimeType = row.entity.FileType;


                        var self = window, // this script is only for browsers anyway...
                            defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
                            mimeType = strMimeType || defaultMime,
                            payload = data,
                            url = !strFileName && !strMimeType && payload,
                            anchor = document.createElement("a"),
                            toString = function(a) {
                                return String(a);
                            },
                            myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
                            fileName = strFileName || "download",
                            blob,
                            reader;
                        myBlob = myBlob.call ? myBlob.bind(self) : Blob;

                        if (String(this) === "true") { //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
                            payload = [payload, mimeType];
                            mimeType = payload[0];
                            payload = payload[1];
                        }


                        if (url && url.length < 2048) { // if no filename and no mime, assume a url was passed as the only argument
                            fileName = url.split("/").pop().split("?")[0];
                            anchor.href = url; // assign href prop to temp anchor
                            if (anchor.href.indexOf(url) !== -1) { // if the browser determines that it's a potentially valid url path:
                                var ajax = new XMLHttpRequest();
                                ajax.open("GET", url, true);
                                ajax.responseType = 'blob';
                                ajax.onload = function(e) {
                                    download(e.target.response, fileName, defaultMime);
                                };
                                setTimeout(function() {
                                    ajax.send();
                                }, 0); // allows setting custom ajax headers using the return:
                                return ajax;
                            } // end if valid url?
                        } // end if url?


                        //go ahead and download dataURLs right away
                        if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {

                            if (payload.length > (1024 * 1024 * 1.999) && myBlob !== toString) {
                                payload = dataUrlToBlob(payload);
                                mimeType = payload.type || defaultMime;
                            } else {
                                return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
                                    navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
                                    saver(payload); // everyone else can save dataURLs un-processed
                            }

                        } //end if dataURL passed?

                        blob = payload instanceof myBlob ?
                            payload :
                            new myBlob([payload], {
                                type: mimeType
                            });


                        function dataUrlToBlob(strUrl) {
                            var parts = strUrl.split(/[:;,]/),
                                type = parts[1],
                                decoder = parts[2] == "base64" ? atob : decodeURIComponent,
                                binData = decoder(parts.pop()),
                                mx = binData.length,
                                i = 0,
                                uiArr = new Uint8Array(mx);

                            for (i; i < mx; ++i) uiArr[i] = binData.charCodeAt(i);

                            return new myBlob([uiArr], {
                                type: type
                            });
                        }

                        function saver(url, winMode) {

                            if ('download' in anchor) { //html5 A[download]
                                anchor.href = url;
                                anchor.setAttribute("download", fileName);
                                anchor.className = "download-js-link";
                                anchor.innerHTML = "downloading...";
                                anchor.style.display = "none";
                                document.body.appendChild(anchor);
                                setTimeout(function() {
                                    anchor.click();
                                    document.body.removeChild(anchor);
                                    if (winMode === true) {
                                        setTimeout(function() {
                                            self.URL.revokeObjectURL(anchor.href);
                                        }, 250);
                                    }
                                }, 66);
                                return true;
                            }

                            // handle non-a[download] safari as best we can:
                            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                                url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                                if (!window.open(url)) { // popup blocked, offer direct download:
                                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
                                        location.href = url;
                                    }
                                }
                                return true;
                            }

                            //do iframe dataURL download (old ch+FF):
                            var f = document.createElement("iframe");
                            document.body.appendChild(f);

                            if (!winMode) { // force a mime that will download:
                                url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                            }
                            f.src = url;
                            setTimeout(function() {
                                document.body.removeChild(f);
                            }, 333);

                        } //end saver




                        if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
                            return navigator.msSaveBlob(blob, fileName);
                        }

                        if (self.URL) { // simple fast and modern way using Blob and URL:
                            saver(self.URL.createObjectURL(blob), true);
                        } else {
                            // handle non-Blob()+non-URL browsers:
                            if (typeof blob === "string" || blob.constructor === toString) {
                                try {
                                    return saver("data:" + mimeType + ";base64," + self.btoa(blob));
                                } catch (y) {
                                    return saver("data:" + mimeType + "," + encodeURIComponent(blob));
                                }
                            }

                            // Blob but not URL support:
                            reader = new FileReader();
                            reader.onload = function(e) {
                                saver(this.result);
                            };
                            reader.readAsDataURL(blob);
                        }
                        return true;


                    }
                },
                function errorcallback(response) {
                    // Utility.ServiceErrorCallback(response, $scope.WareHouseReceiptBO.TransactionAdd);
                    toaster.error("Acction Failed", "now only attached this");
                });
        } else {
            toaster.pop("warning", "now only attached this");
        }




    },

    AddAttachment: function(attachData) {

        fileData = document.getElementById("file").files[0];

        if (fileData != undefined) {

            attachData.FileName = fileData.name;

            if (fileData.size != 0) {
                var fileSize = (fileData.size / 1024).toFixed(2);
                if (fileSize / 1024 >= 1)
                    fileSize = (fileSize / 1024).toFixed(2) + " MB.";
                else
                    fileSize = fileSize + " KB.";

                attachData.Filesize = fileSize;
            }

            attachData.FileType = fileData.type;
            var filetest = attachData.Attachment;
            var data = new Blob([attachData.Attachment], {
                type: fileData.type
            });
            attachData.fileData = URL.createObjectURL(data);

            return attachData;
        }

    },

    AttachmentGrid: function() {

        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var defaultvalue = AppData.GridPagination;

        Data = {
            data: "AttachmentData",
            enableSorting: true,
            paginationPageSizes: [defaultvalue, 30, 45],
            paginationPageSize: defaultvalue,
            rowHeight: 29,
            enableColumnResizing: true,
            enableFiltering: false,
            enableCellEditOnFocus: false,
            enableCellEdit: false,
            columnDefs: [{
                    field: "ReferenceNumber",
                    displayName: "Title",
                    width: '15%',
                    cellClass: "text-left"
                },
                {
                    field: "Attachment",
                    displayName: "Attachment",
                    width: '18%',
                    cellTemplate: '<div class="main"><div id="Head"><div id="Child"></div></div><div><a>' +
                        '<label class="VA-Enabled-Link" ng-if="row.entity.ID > 0" style="cursor:pointer; color:#209e91" ng-click="grid.appScope.download(row)">{{row.entity.FileName}}</label>' +
                        '<label class="VA-Disabled-Link" title="Disabled" ng-if="row.entity.ID==0 || row.entity.ID==undefined" ng-click="grid.appScope.download(row)">{{row.entity.FileName}}</label>' +
                        '</a></div></div>'
                },
                {
                    field: "Filesize",
                    displayName: "File size",
                    width: '8%',
                    cellClass: "text-left"
                },
                {
                    field: 'Description',
                    displayName: 'Description',
                    cellClass: 'text-right',
                    width: '57%',
                    cellTemplate: '<div><textarea class="form-control Resizenone" autogrow  name="InquiryDescription" wrap="hard" style="width: 100%;height:34px;" ng-model="row.entity.Description" ng-blur="grid.appScope.AttachmentRow(row)" class="form-control" capitalize-first/></div>',
                    editableCellTemplate: '<div><textarea class="form-control Resizenone" autogrow  name="InquiryDescription"  wrap="hard" style="width: 100%;height:34px;" ng-model="row.entity.Description"  ng-blur="grid.appScope.AttachmentRow(row)"  class="form-control" capitalize-first/></div>'
                },
                {
                    field: "  ",
                    displayName: " ",
                    enableCellEdit: false,
                    width: 40,
                    cellClass: "text-right",
                    cellTemplate: '<div class="col-lg-12 col-md-12 col-sm-12  "><label  class="deleteIcon ion-trash-a" ng-Click="grid.appScope.DeleteAttachmentRow(row)"></label></div>'
                }
            ]
        };

        return Data;
    },

    toTime: function(timeString) {
        var timeTokens = timeString.split(':');
        return new Date(1970, 0, 1, timeTokens[0], timeTokens[1], timeTokens[2]);
    },

    Roundingtwodigits(data) {
        return data.toFixed(2);
    },

    ViewAttachmentGrid: function() {

        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var defaultvalue = AppData.GridPagination;

        var Data = {
            data: "AttachmentData",
            enableSorting: true,
            paginationPageSizes: [defaultvalue, 30, 45],
            paginationPageSize: defaultvalue,
            rowHeight: 29,
            enableColumnResizing: true,
            enableFiltering: false,
            enableCellEditOnFocus: false,
            enableCellEdit: false,
            columnDefs: [{
                    field: "ReferenceNumber",
                    displayName: "Title",
                    width: '15%',
                    cellClass: "text-left"
                },
                {
                    field: "Attachment",
                    displayName: "Attachment",
                    width: '18%',
                    cellTemplate: '<div class="main"><div id="Head"><div id="Child"></div></div><div><a><label style="cursor:pointer;" ng-click="grid.appScope.download(row)">{{row.entity.FileName}}</label></a></div></div>'
                },
                {
                    field: "Filesize",
                    displayName: "File size",
                    width: '8%',
                    cellClass: "text-left"
                },
                {
                    field: "Description",
                    displayName: "Description",
                    width: '59%',
                    cellTemplate: '<div><pre class="preDescription">{{row.entity.Description}}</pre></div>',
                    editableCellTemplate: '<div><pre class="preDescription">{{row.entity.Description}}</pre></div>',
                    cellClass: 'text-left'
                }

            ]
        };

        return Data;

    },

    SetAttachmentFileSize: function(AttachmentData) {
        angular.forEach(AttachmentData, function(key, value) {
            //var fileSize = (parseInt((key.Attachment).replace(/=/g, "").length * 0.75));

            //if (fileSize != 0) {
            //    fileSize = (fileSize / 1024).toFixed(2);
            //    if (fileSize / 1024 >= 1)
            //        fileSize = (fileSize / 1024).toFixed(2) + " MB";
            //    else
            //        fileSize = fileSize + " KB";

            //    key.Filesize = fileSize;

            //    if (key.ReferenceNumber != null && key.ReferenceNumber != '' && key.ReferenceNumber != undefined && key.ReferenceNumber != "null" && key.ReferenceNumber != "undefined")
            //        key.ReferenceNumber = (key.ReferenceNumber)
            //    else
            //        key.ReferenceNumber = null;


            //    if (key.Description != null && key.Description != '' && key.Description != undefined && key.Description != "null" && key.Description != "undefined")
            //        key.Description = this.unescape(key.Description)
            //    else
            //        key.Description = null;

            //}
        });

        return AttachmentData;
    },

    GetSession: function(key) {
        return sessionStorage.getItem(key);
    },

    SetSession: function(key, Value) {
        sessionStorage.setItem(key, Value);
    },

    RemoveSession: function(key) {
        sessionStorage.removeItem(key);
    },

    RemoveAllSession: function() {
        sessionStorage.clear();
    },

    GetFromLocalStorage: function(key) {
        return localStorage.getItem(key);
    },

    SetToLocalStorage: function(key, Value) {
        localStorage.setItem(key, Value);
    },

    RemoveFromLocalStorage: function(key) {
        localStorage.removeItem(key);
    },

    ReturnValueOrEmpty: function(src) {
        return (src != null || src != undefined) ? src : '';
    },

    UniquieList: function(List) {
        return List.filter((x, i, a) => a.indexOf(x) == i);
    },

    AddSpace: function(data) {
        if (data != null && data != undefined && data != "") {
            data = data.replace(/([A-Z])/g, ' $1').trim()
        }
        return data;
    },

    InvoicePrintStyles: function() {
        return {
            'emptylineSpacingAfterTable': {
                margin: [10, 10, 10, 10]
            },
            'pdfbankstyle': {
                margin: [2, 3, 3, 3],
                lineHeight: 1.5
            },
            'emptylineSpacingBeforeTable': {
                margin: [10, 1, 10, 10]
            },
            'emptylineSpacing': {
                margin: [50, 50, 50, 30]
            },
            'lineSpacing': {
                margin: [35, -20, 50, 10],
            },
            'lineSpacingheader': {
                margin: [35, -20, 50, 10]
            },
            'doublelineSpacing': {
                margin: [0, 0, 0, 12]
            },
            'headingColor': {
                color: '#999966'
            },
            Linecount: {
                pageBreak: 'before'
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: '#669999'
            },
            image: {
                alignment: 'center',
                margin: [10, 10, 10, 10]
            },
            table1: {
                absolutePosition: {
                    x: 360,
                    y: 250
                },
            },
            Rightalign: {
                alignment: 'right',
                fontSize: 10,
            },
            Leftalign: {
                alignment: 'left',
                fontSize: 10,
            },
            centeralign: {
                alignment: 'center',
                fontSize: 10,
            },
            header: {
                fontSize: 10,
                bold: true,
                alignment: 'center',
                margin: [0, 4, 0, 3]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            },
            bold: {
                bold: true,
            },
            boldstamp: {
                bold: true,
                alignment: 'center',
            },
        }
    },

    GetLandscapePDFStyles: function() {
        return {
            'emptylineSpacingAfterTable': {
                margin: [10, 10, 10, 10]
            },
            emptylineSpacing: {
                margin: [50, 50, 50, 30]
            },
            lineSpacing: {
                margin: [35, -20, 50, 10]
            },
            'lineSpacingheader': {
                margin: [35, -20, 50, 10]
            },
            image: {
                alignment: 'center',
                margin: [10, 10, 10, 10]
            },
            Headers: {
                alignment: 'center',
                fontSize: 10
            },
            timesheetcolumn: {

                margin: [10, 100, 100, 100],
            },
            tableExample: {
                heights: [20, 20, 20],
                widths: [140, 140, 140],
            },
            tab: {
                fontSize: 10,
                margin: [0, 1, 0, 0]
            },
            tab3: {
                fontSize: 10,

            },
            teamleft: {
                fontSize: 10,
                bold: false,
                alignment: "left"
            },
            serialcenter: {
                fontSize: 10,
                bold: false,
                alignment: "center"
            },
            head: {
                fontSize: 10,
                bold: false,
                alignment: "right"
            },
            RightAlign: {
                alignment: 'right',
                bold: true
            },
            header: {
                fontSize: 10,
                bold: true,
                margin: [0, 4, 0, 3],
                alignment: 'center',
            },
            rowheight: {
                heights: [10, 10, 10, 10, 10]
            },
            emptylineSpacingAftermasterdetails: {
                margin: [0, 0, 0, 3]
            }
        }
    },

    TabToggle: function(TabInfo) {
        angular.forEach(TabInfo.TabDetails, function(key, value) {
            if (TabInfo.SelectedTabIndex == key.TabIndex) {
                key.IsTabEnabled = true;
            } else {
                key.IsTabEnabled = false;
            }
        });
        return TabInfo;
    },


    isEqual: function(value, other) {

        // ...

        // Compare properties
        if (type === '[object Array]') {
            for (var i = 0; i < valueLen; i++) {
                if (compare(value[i], other[i]) === false) return false;
            }
        } else {
            for (var key in value) {
                if (value.hasOwnProperty(key)) {
                    if (compare(value[key], other[key]) === false) return false;
                }
            }
        }

        // If nothing failed, return true
        return true;

    },

    ConverAmounttooWords: function(totalAmount) {

        var totalAmountInWords = '';
        var junkVal = totalAmount;
        junkVal = Math.floor(junkVal);
        var number = new String(junkVal);

        if (typeof number === 'string') {
            number = parseInt(number, 10);
        }

        var digits = number.split('');
        while (digits.length % 3 !== 0) {
            digits.unshift('0');
        }

        var digitsGroup = [];
        var numberOfGroups = digits.length / 3;
        for (var i = 0; i < numberOfGroups; i++) {
            digitsGroup[i] = digits.splice(0, 3);
        }

        var digitsGroupLen = digitsGroup.length;

        var numTxt = [
            [null, " One", " Two", " Three", " Four", " Five", " Six", " Seven", " Eight", " Nine"], //hundreds
            [null, ' Ten', ' Twenty', ' Thirty', ' Forty', ' Fifty', ' Sixty', ' Seventy', ' Eighty', ' Ninety'], //tens
            [null, " One", " Two", " Three", " Four", " Five", " Six", " Seven", " Eight", " Nine"] //ones
        ];
        var tenthsDifferent = ['Ten', ' Eleven', ' Twelve', ' Thirteen', ' Fourteen', ' Fifteen', ' Sixteen', ' Seventeen', ' Eighteen', ' Nineteen'];


        for (var j = 0; j < digitsGroupLen; j++) {
            for (var k = 0; k < 3; k++) {
                var currentValue = digitsGroup[j][k];
                digitsGroup[j][k] = numTxt[k][currentValue];
                if (k === 0 && currentValue !== '0') {
                    digitsGroup[j][k] += ' Hundred ';
                } else if (k === 1 && currentValue === '1') {
                    digitsGroup[j][k] = tenthsDifferent[digitsGroup[j][2]];
                    digitsGroup[j][2] = 0;
                }
            }
        }

        for (var l = 0; l < digitsGroupLen; l++) {
            if (digitsGroup[l][1] && digitsGroup[l][2]) {
                digitsGroup[l][1] += ' ';
            }
            digitsGroup[l].filter(function(e) {
                return e !== null
            });
            digitsGroup[l] = digitsGroup[l].join('');
        }

        var posfix = [null, 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion', 'Quintillion', 'Sextillion'];
        if (digitsGroupLen > 1) {
            var posfixRange = posfix.splice(0, digitsGroupLen).reverse();
            for (var m = 0; m < digitsGroupLen - 1; m++) {
                if (digitsGroup[m]) {
                    digitsGroup[m] += ' ' + posfixRange[m];
                }
            }
        }

        var Newvalue = digitsGroup.join(' ');

        if (Newvalue != "")
            totalAmountInWords = (digitsGroup.join(' ')) + " Only ";
        else
            totalAmountInWords = '';

        return totalAmountInWords;
    },

    // // service error callback apply for common methods - Developed by Mani @21-9-2018
    // //eg. -> Utility.ServiceErrorCallback($scope.Issue.TranscationAdd)
    // ServiceErrorCallback: function (Page) {
    //     clearTimeout(Page.DataModel.UIData.Savetimer);
    //     this.SessionTimeout(Page);
    //     Page.PageLoadStatus = 'none';
    //     toaster.error(ServiceUnavailableError);
    // },


    // service error callback apply for common methods
    //eg. -> Utility.ServiceErrorCallback($scope.Issue.TranscationAdd)
    ServiceErrorCallback: function(response, Page) {
        clearTimeout(Page.DataModel.UIData.Savetimer);
        this.SessionTimeout(Page);
        Page.PageLoadStatus = 'none';
        this.ResponceErrorMessage(response);
    },

    // to show error message based on response status
    ResponceErrorMessage: function(response) {
        switch (response.status) {
            case 404:
                toaster.error(NotFoundError);
                break;
            case -1:
                toaster.error(ServiceUnavailableError);
                break;
            default:
                toaster.info(NoResponseInTime);
                break;
        }
    },

    // session remainder call for common methods - Developed by Mani @21-9-2018
    //eg. -> Utility.SessionTimeout($scope.Issue.TranscationAdd)
    SessionTimeout: function(Page) {
        Page.SessionInfo.SessionTimeout = true;
        this.SetSession('SessionData', JSON.stringify(Page.SessionInfo));
    },


    // Page loader start call for common methods - Developed by Mani @21-9-2018
    //eg. -> Utility.startLoader($scope.Issue.TranscationAdd)
    startLoader: function(Page) {
        Page.DataModel.UIData.Savetimer = setTimeout(function() {
            if (Page.PageLoadStatus == 'block') {
                Page.PageLoadStatus = 'none';
                toaster.info(NoResponseInTime);
            }
        }, Page.SessionInfo.AppConfig.LoaderTime);
    },

    //style for (order confimation and delivery note)
    GetPDFStyles: function() {
        return {
            'emptylineSpacingAfterTable': {
                margin: [2, 3, 3, 3],
                // lineHeight: 1.5
            },
            'emptylineSpacingBeforeTable': {
                margin: [10, 1, 10, 10]
            },
            'pdfbankstyle': {
                margin: [2, 3, 3, 3],
                lineHeight: 1.5
            },
            'emptylineSpacing': {
                margin: [50, 50, 50, 30]
            },
            'lineSpacing': {
                margin: [35, -20, 50, 10],
            },
            'lineSpacingheader': {
                margin: [35, -20, 50, 10]
            },
            'doublelineSpacing': {
                margin: [0, 0, 0, 12]
            },
            'headingColor': {
                color: '#999966'
            },
            Rightalign: {
                alignment: 'right',
                fontSize: 10,
            },
            subheader2: {
                fontSize: 10,
                alignment: 'left',
                bold: true,
                margin: [0, -3, 0, -30]
            },
            header: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                margin: [0, 4, 0, 3]
            },
            bold: {
                bold: true,
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: '#669999'
            },
            Leftalign: {
                fontSize: 10,
                alignment: 'left',
            },
            CenterAlign2: {
                fontSize: 10,
                alignment: 'left',
            },
            section: {
                fontSize: 9,
                margin: [0, 15, 0, 5]
            },
            MasterTableAlign: {
                absolutePosition: {
                    x: 250,
                    y: 250
                },
                image: {
                    alignment: 'center',
                    margin: [10, 5, 10, 10]
                },
                margin: [0, -10, 0, 0]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            },
            table: {
                heights: [20, 20, 20, 20, 20, 20],
                widths: [100, 150, 100, 100, 50, 100],
                border: [true, true, false, false],
            }
        }
    },

    //For Stop the loader while response not come - Developed by Mani @21-9-2018
    //eg. -> Utility.StopTimer($scope.Issue.TranscationAdd.DataModel.UIData.Savetimer)
    StopTimer: function(timeOut) {
        clearTimeout(timeOut);
    },

    UITabToggle: function(TabInfo, Selected) {

        angular.forEach(TabInfo.TabDetails, function(key, value) {
            if (key.Name == Selected) {
                key.IsTabEnabled = true;
            } else {
                key.IsTabEnabled = false;
            }
        });

    },


    //priority (high,medium,low)
    //
    //

    ErrorMessage: function(error, priority) {

        if (priority == "high") {
            toaster('Error', error);
        } else if (priority == "medium") {
            toaster('info', error);
        } else if (priority == "low") {
            toaster('info', error);
        } else {


        }
    },

    GridHeight: function(Dashboardrow, SessionData) {
        if (Dashboardrow == "true") {
            this.RemoveSession(SessionData);
            var rowHeight = 140;
            var headerHeight = 140;
            return {
                height: (rowHeight + headerHeight) + "px"
            };
        } else {
            var rowHeight = 300;
            var headerHeight = 300;
            return {
                height: (rowHeight + headerHeight) + "px"
            };
        }
    },


    //#region ----------------------------------PDF---Functionality ---AREA------------------------------------------------
    //#region Pdf Common-Margin


    resizeBase64Img: function(base64) {

        var canvas = document.createElement("canvas");

        /* canvas.width = width;

        canvas.height = height; */

        var context = canvas.getContext("2d");

        var deferred = $.Deferred();

        $("<img/>").attr("src", base64).load(function() {

            context.scale(100 / this.width, 100 / this.height);

            context.drawImage(this, 0, 0);

            deferred.resolve($("<img/>").attr("src", canvas.toDataURL()));

        });

        return deferred.promise();

    },



    Pagesmargin: function() {
        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        Pdfmargin = []
        Pdfmargin.push(Number(AppData.LeftMargin));
        Pdfmargin.push(Number(AppData.TopMargin));
        Pdfmargin.push(Number(AppData.RightMargin));
        Pdfmargin.push(Number(AppData.BottomMargin));
        return Pdfmargin;
    },
    //#endregion

    //#region  WaterMark Functionality
    GetPDFWatermark: function() {
        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var watermark = null;
        watermark = {
            text: AppData.PDFWaterMark,
            color: 'gray',
            opacity: 0.1,
            bold: true,
            italics: false
        }
        return watermark;
    },
    //#endregion

    //#region Header Functionality
    GetpdfHeader: function() {

        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var RegisteredAddress = JSON.parse($window.sessionStorage.getItem("RegisteredAddress"));

        // variables declaration

        var RegAddressDoorNo = '';
        var RegAddressStreet = '';
        var RegAddressCity = '';
        var RegAddressStateName = '';
        var RegAddressCountryName = '';
        var RegAddressZipCode = '';
        var RegAddressName = '';
        var RegAddressTelephoneNo = '';
        var RegAddressSTDCode = '';
        var RegAddressMobileNo = '';
        var RegAddressEmail = '';
        var RegAddressFax = '';

        var BranchAddressDoorNo = '';
        var BranchAddressStreet = '';
        var BranchAddressStateName = '';
        var BranchAddressCountryName = '';
        var BranchAddressZipCode = '';
        var BranchAddressName = '';
        var BranchAddressTelephoneNumber = '';
        var BranchAddressSTDCode = '';
        var BranchAddressMobileNumber = '';
        var BranchAddressEmail = '';
        var BranchAddressFax = '';


        if (RegisteredAddress != null) {

            RegAddressDoorNo = this.CheckforNull(RegisteredAddress.Address1);
            RegAddressStreet = this.CheckforNull(RegisteredAddress.Address2);
            RegAddressCity = this.CheckforNull(RegisteredAddress.City);
            RegAddressStateName = this.CheckforNull(RegisteredAddress.State.Name);
            RegAddressCountryName = this.CheckforNull(RegisteredAddress.Country.Name);
            RegAddressZipCode = this.CheckforNull(RegisteredAddress.ZipCode);
            RegAddressName = this.CheckforNull(RegisteredAddress.Name);
            RegAddressTelephoneNo = this.CheckforNull(RegisteredAddress.TelephoneNumber);
            RegAddressSTDCode = this.CheckforNull(RegisteredAddress.STDCode);
            RegAddressMobileNo = this.CheckforNull(RegisteredAddress.MobileNumber);
            RegAddressEmail = this.CheckforNull(RegisteredAddress.Email);
            RegAddressFax = this.CheckforNull(RegisteredAddress.Fax);
        }

        if (AppData.BranchAddress.Address != null) {

            BranchAddressDoorNo = this.CheckforNull(AppData.BranchAddress.Address.Address1);
            BranchAddressStreet = this.CheckforNull(AppData.BranchAddress.Address.Address2);
            BranchAddressCity = this.CheckforNull(AppData.BranchAddress.Address.City);
            BranchAddressStateName = this.CheckforNull(AppData.BranchAddress.Address.State.Name);
            BranchAddressCountryName = this.CheckforNull(AppData.BranchAddress.Address.Country.Name);
            BranchAddressZipCode = this.CheckforNull(AppData.BranchAddress.Address.ZipCode);
            BranchAddressName = this.CheckforNull(AppData.BranchAddress.Name);
            BranchAddressTelephoneNumber = this.CheckforNull(AppData.BranchAddress.Address.TelephoneNumber);
            BranchAddressSTDCode = this.CheckforNull(AppData.BranchAddress.Address.TelephoneNumber);
            BranchAddressMobileNumber = this.CheckforNull(AppData.BranchAddress.Address.MobileNumber);
            BranchAddressEmail = this.CheckforNull(AppData.BranchAddress.Address.Email);
            BranchAddressFax = this.CheckforNull(AppData.BranchAddress.Address.Fax);
        }



        var HeaderLeft = AppData.HeaderAlignment.Left.Name;
        var HeaderRight = AppData.HeaderAlignment.Right.Name;
        var HeaderCenter = AppData.HeaderAlignment.Center.Name;




        var lineheight = Number($window.sessionStorage.getItem('lineheight'));
        var logo = window.localStorage.getItem("PDFLogo");
        //var logo = $window.localStorage.getItem('Logo');
        if (!(this.isNotUndefindeOrEmpty(logo)))
            logo = null;

        var Emptylogo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMUAAACPCAYAAABK+x/6AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFbSURBVHhe7dMxAQAwEAOh+jedzn8awANvwCEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBQQUkBIASEFhBRwbB/RrI1/CWrxyQAAAABJRU5ErkJggg==';
        var headofficepartOne = '';
        var headofficepartTwo = '';
        var headOfficeAddress = '';
        var headOfficetelephonenumber = '';

        // head office header
        headofficepartOne = (RegAddressDoorNo);
        if (RegAddressStreet != '')
            headofficepartOne += (' , ') + (RegAddressStreet);
        else if (RegAddressCity != '') {
            headofficepartOne += (RegAddressCity);
        }
        if (RegAddressStateName != '')
            headofficepartTwo = '\n' + (RegAddressStateName);

        if (RegAddressCountryName != '')
            headofficepartTwo += (' , ') + (RegAddressCountryName);

        if (RegAddressZipCode != '')
            headofficepartTwo += (',') + RegAddressZipCode;

        if (RegAddressSTDCode != '' && RegAddressTelephoneNo != '')
            headOfficetelephonenumber = (RegAddressSTDCode) + ' - ' + (RegAddressTelephoneNo);
        else
            headOfficetelephonenumber = RegAddressTelephoneNo;


        var branchOfficepartOne = '';
        var branchOfficepartTwo = '';
        var branchOfficeAddress = '';
        var branchtelephonenumber = '';

        // branch office
        if (BranchAddressName != '')
            branchOfficepartTwo += (',') + BranchAddressZipCode;

        branchOfficepartOne = (BranchAddressName + '' + BranchAddressDoorNo);
        if (BranchAddressStreet != '')
            branchOfficepartOne += (' , ') + (BranchAddressStreet)
        else if (BranchAddressCity != '')
            branchOfficepartOne += (' , ') + (BranchAddressCity);

        if (BranchAddressStateName != '')
            branchOfficepartTwo = '\n' + (BranchAddressStateName);
        if (BranchAddressCountryName != '')
            branchOfficepartTwo += (' , ') + (BranchAddressCountryName);
        if (BranchAddressZipCode != '')
            branchOfficepartTwo += (',') + BranchAddressZipCode;


        if (BranchAddressSTDCode != '' && BranchAddressTelephoneNumber != '')
            branchtelephonenumber = (BranchAddressSTDCode) + ' - ' + (BranchAddressTelephoneNumber);
        else
            branchtelephonenumber = BranchAddressTelephoneNumber;

        if (headOfficetelephonenumber != '')
            headOfficetelephonenumber = '\n' + 'Tel : ' + headOfficetelephonenumber;
        if (RegAddressMobileNo != '')
            RegAddressMobileNo = '\n' + 'Mobile No : ' + RegAddressMobileNo;
        if (RegAddressEmail != '')
            RegAddressEmail = '\n' + 'Email : ' + (RegAddressEmail);

        if (RegAddressFax != '')
            RegAddressFax = '\n' + 'Fax : ' + (RegAddressFax);


        if (branchtelephonenumber != '')
            branchtelephonenumber = '\n' + 'Tel : ' + branchtelephonenumber;
        if (BranchAddressMobileNumber != '')
            BranchAddressMobileNumber = '\n' + 'Mobile No : ' + (BranchAddressMobileNumber);
        if (BranchAddressEmail != '')
            BranchAddressEmail = '\n' + 'Email : ' + (BranchAddressEmail);
        if (BranchAddressFax != '')
            BranchAddressFax = '\n' + 'Fax : ' + (BranchAddressFax);

        var FirstColumn = '';
        var SecondColumn = '';
        var ThirdColumn = '';
        var headerbody = [];
        var rowdata = [];
        // }
        // $scope.getheaderColumns = function () {
        var Count = 1;
        widthsize2 = [];
        leftaddwidth = '43%'
        Centerwidth = '37%'
        rightwidth = '20%'
        for (i = 1; i <= 3; i++) {
            switch (Count) {
                case 1:
                    if (HeaderLeft != null) {
                        if (HeaderLeft == "Logo") {
                            var companyLogo = {
                                image: ((logo != null) ? logo : Emptylogo),
                                style: 'center',
                                fit: [140, 60],
                                border: [false, false, false, 10],
                                alignment: 'left'
                            }
                            FirstColumn = companyLogo;

                        } else if (HeaderLeft == "Head Office Address") {
                            headOfficeAddress = {
                                text: ('Head Office : ' + (headofficepartOne) + headofficepartTwo + headOfficetelephonenumber +
                                    (RegAddressMobileNo) + (RegAddressEmail) + (RegAddressFax)),
                                fontSize: 8,
                                style: {
                                    lineHeight: lineheight
                                },
                                alignment: 'left',
                                border: [false, false, false, 10]
                            };
                            FirstColumn = headOfficeAddress;

                        } else if (HeaderLeft == "Branch Address") {
                            branchOfficeAddress = {
                                text: 'Branch Office : ' + branchOfficepartOne + branchOfficepartTwo +
                                    branchtelephonenumber +
                                    (BranchAddressMobileNumber) + (BranchAddressEmail) + (BranchAddressFax),
                                fontSize: 8,
                                style: {
                                    lineHeight: lineheight
                                },
                                border: [false, false, false, 10],
                                alignment: 'left',
                            };
                            FirstColumn = branchOfficeAddress;

                        } else if (HeaderLeft == "none") {
                            branchOfficeAddress = {
                                text: '',
                                fontSize: 8,
                                style: {
                                    lineHeight: lineheight
                                },
                                border: [false, false, false, 10],
                                alignment: 'left',
                            };
                            FirstColumn = branchOfficeAddress;

                        }
                        rowdata.push(FirstColumn);
                    } else {
                        branchOfficeAddress = {
                            text: '',
                            fontSize: 8,
                            style: {
                                lineHeight: lineheight
                            },
                            border: [false, false, false, 10],
                            alignment: 'left',
                        };
                        FirstColumn = branchOfficeAddress;
                        rowdata.push(FirstColumn);
                    }
                    break;
                case 3:
                    if (HeaderRight != null) {
                        if (HeaderRight == "Logo") {
                            var companyLogo = {
                                image: ((logo != null) ? logo : Emptylogo),
                                // style: 'center',
                                fit: [140, 60],
                                border: [false, false, false, 10],
                                alignment: 'right'
                            }
                            SecondColumn = companyLogo;

                        } else if (HeaderRight == "Head Office Address") {
                            headOfficeAddress = {
                                text: ('Head Office : ' + (headofficepartOne) + headofficepartTwo + headOfficetelephonenumber +
                                    (RegAddressMobileNo) + (RegAddressEmail) + (RegAddressFax)),
                                fontSize: 8,
                                style: {
                                    lineHeight: lineheight
                                },
                                border: [false, false, false, 10],
                                alignment: 'right'
                            };
                            SecondColumn = headOfficeAddress;

                        } else if (HeaderRight == "Branch Address") {
                            branchOfficeAddress = {
                                text: 'Branch Office : ' + branchOfficepartOne + branchOfficepartTwo +
                                    branchtelephonenumber +
                                    (BranchAddressMobileNumber) + (BranchAddressEmail) + (BranchAddressFax),
                                fontSize: 8,
                                style: {
                                    lineHeight: lineheight
                                },
                                border: [false, false, false, 10],
                                alignment: 'right'
                            };
                            SecondColumn = branchOfficeAddress;

                        } else if (HeaderRight == "none") {
                            branchOfficeAddress = {
                                text: '',
                                fontSize: 8,
                                style: {
                                    lineHeight: lineheight
                                },
                                border: [false, false, false, 10],
                                alignment: 'right'
                            };
                            SecondColumn = branchOfficeAddress;

                        }
                        rowdata.push(SecondColumn);
                    } else {
                        branchOfficeAddress = {
                            text: '',
                            fontSize: 8,
                            style: {
                                lineHeight: lineheight
                            },
                            border: [false, false, false, 10],
                            alignment: 'right'
                        };
                        SecondColumn = branchOfficeAddress;
                        rowdata.push(SecondColumn);
                    }
                    break;
                case 2:
                    if (HeaderCenter != null) {
                        if (HeaderCenter == "Logo") {
                            var companyLogo = {
                                image: ((logo) ? logo : Emptylogo),
                                //style: 'center',
                                fit: [140, 60],
                                border: [false, false, false, 10],
                                alignment: 'center'
                            }
                            ThirdColumn = companyLogo;

                        } else if (HeaderCenter == "Head Office Address") {
                            headOfficeAddress = {
                                text: ('Head Office : ' + (headofficepartOne) + headofficepartTwo + headOfficetelephonenumber +
                                    (RegAddressMobileNo) + (RegAddressEmail) + (RegAddressFax)),
                                fontSize: 8,
                                style: {
                                    lineHeight: lineheight
                                },
                                alignment: 'left',
                                border: [false, false, false, 10]
                            };
                            ThirdColumn = headOfficeAddress;

                        } else if (HeaderCenter == "Branch Address") {
                            branchOfficeAddress = {
                                text: 'Branch Office : ' + branchOfficepartOne + branchOfficepartTwo +
                                    branchtelephonenumber +
                                    (BranchAddressMobileNumber) + (BranchAddressEmail) + (BranchAddressFax),
                                fontSize: 8,
                                style: {
                                    lineHeight: lineheight
                                },
                                border: [false, false, false, 10],
                                alignment: 'left',
                            };
                            ThirdColumn = branchOfficeAddress;

                        } else if (HeaderCenter == "none") {
                            branchOfficeAddress = {
                                text: '',
                                fontSize: 8,
                                style: {
                                    lineHeight: lineheight
                                },
                                border: [false, false, false, 10],
                                alignment: 'left',
                            };
                            ThirdColumn = branchOfficeAddress;

                        }
                        rowdata.push(ThirdColumn);
                    } else {

                        branchOfficeAddress = {
                            text: '',
                            fontSize: 8,
                            style: {
                                lineHeight: lineheight
                            },
                            border: [false, false, false, 10],
                            alignment: 'left',
                        };
                        ThirdColumn = branchOfficeAddress;
                        rowdata.push(ThirdColumn);
                    }
                    headerbody.push(rowdata);

                    break;

                default:
                    headerbody.push(FirstColumn);
                    headerbody.push(SecondColumn);
                    headerbody.push(ThirdColumn);
                    headerbody;
                    break;
            }
            Count++;
        }
        return headerbody;

    },

    PdfDocHeaderBorderLayout: function() {
        var Layout = {
            hLineWidth: function(i, node) {
                return 0.5;
            },
            hLineColor: function(i, node) {
                return 'black';
            }
        }

        return Layout

    },
    //calculation of pdfpageheader
    headermargin: function() {
        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        var headermargin = []
        headermargin.push(Number(AppData.LeftMargin));
        var topmargins = Number(AppData.TopMargin);
        if (topmargins <= 120) {
            headermargin.push((Number(AppData.HeaderFromTop)))
        } else {
            headermargin.push(Number(AppData.HeaderFromTop))
        }
        headermargin.push(Number(AppData.RightMargin));
        headermargin.push(0);
        return headermargin;
    },
    //#endregion

    //#region Footer Functionality
    Getpdffooter: function(currentPage, pageCount) {

        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));
        AppData.Accreditation.File;

        if (AppData.FooterAlignment.Left)
            AppData.FooterText

        var logo = AppData.Accreditation.File;
        var FirstFooterColumn = '';
        var SecondFooterColumn = '';
        var ThirdFooterColumn = '';

        var FooterWidth = [];
        leftFooterwidth = '43%'
        CenterFooterwidth = '37%'
        rightFooterwidth = '20%'


        var FooterBody = [];
        var columndata = [];


        var LeftFooter = (AppData.FooterAlignment.Left.Name != "none") ? AppData.FooterAlignment.Left.Name : ""
        var RightFooter = (AppData.FooterAlignment.Right.Name != "none") ? AppData.FooterAlignment.Right.Name : ""
        var CenterFooter = (AppData.FooterAlignment.Center.Name != "none") ? AppData.FooterAlignment.Center.Name : ""


        //Page Number Footer side
        if (LeftFooter == 'Page Number') {
            var PageNumberDemo = {
                text: this.pageNumberReplace(currentPage, pageCount),
                border: [false, true, false, false],
                margin: [0, 0, 0, 25],
                alignment: 'left',
                fontSize: 8,
            }
            FirstFooterColumn = PageNumberDemo;
            FooterWidth.push(leftFooterwidth)
        } else if (LeftFooter == 'Text Area') {
            var TextareaDemo = {
                text: (AppData.FooterText != null || AppData.FooterText != null) ? AppData.FooterText : '',
                border: [false, true, false, false],
                alignment: 'left',
                fontSize: 8,
            }
            FirstFooterColumn = TextareaDemo;
            FooterWidth.push(leftFooterwidth)
        } else if (LeftFooter == 'Accreditation') {
            var FooterimageDemo = {
                image: (logo != null || logo != undefined) ? logo : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANUAAAA8CAYAAADxC//JAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC1SURBVHhe7dMxAQAADMOg+TfdmcgJHrgBKakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpILU9j3E8+v/7ZAlAAAAAElFTkSuQmCC',
                fit: [45, 40],
                border: [false, true, false, false],
                alignment: 'left',
                fontSize: 8,

            }
            FirstFooterColumn = FooterimageDemo;
            FooterWidth.push(leftFooterwidth)
        } else if (LeftFooter == "" || LeftFooter == null) {
            var FooternoneDemo = {
                text: (AppData.FooterText == null || AppData.FooterText == null) ? AppData.FooterText : '',
                border: [false, true, false, false],
                alignment: 'left',
                fontSize: 8,

            }
            FirstFooterColumn = FooternoneDemo;
            FooterWidth.push(leftFooterwidth)
        }


        if (CenterFooter == 'Page Number') {
            var PageNumberDemo = {
                text: this.pageNumberReplace(currentPage, pageCount),
                border: [false, true, false, false],
                margin: [0, 0, 0, 25],
                alignment: 'center',
                fontSize: 8,
            }
            SecondFooterColumn = PageNumberDemo;
            FooterWidth.push(CenterFooterwidth)
        } else if (CenterFooter == 'Text Area') {
            var TextareaDemo = {
                text: (AppData.FooterText != null || AppData.FooterText != null) ? AppData.FooterText : '',
                border: [false, true, false, false],
                alignment: 'center',
                fontSize: 8,
            }
            SecondFooterColumn = TextareaDemo;
        } else if (CenterFooter == 'Accreditation') {
            var FooterimageDemo = {
                image: (logo != null || logo != undefined) ? logo : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANUAAAA8CAYAAADxC//JAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC1SURBVHhe7dMxAQAADMOg+TfdmcgJHrgBKakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpILU9j3E8+v/7ZAlAAAAAElFTkSuQmCC',
                fit: [45, 40],
                border: [false, true, false, false],
                alignment: 'center',
                fontSize: 8,

            }
            SecondFooterColumn = FooterimageDemo;
            FooterWidth.push(CenterFooterwidth)
        } else if (CenterFooter == "" || CenterFooter == null) {
            var FooternoneDemo = {
                text: (AppData.FooterText == null || AppData.FooterText == null) ? AppData.FooterText : '',
                border: [false, true, false, false],
                alignment: 'left',
                fontSize: 8,

            }
            SecondFooterColumn = FooternoneDemo;
            FooterWidth.push(CenterFooterwidth)
        }



        if (RightFooter == 'Page Number') {
            var PageNumberDemo = {
                text: this.pageNumberReplace(currentPage, pageCount),
                border: [false, true, false, false],
                margin: [0, 0, 0, 25],
                alignment: 'right',
                fontSize: 8,
            }
            ThirdFooterColumn = PageNumberDemo;
            FooterWidth.push(rightFooterwidth)
        } else if (RightFooter == 'Text Area') {
            var TextareaDemo = {
                text: (AppData.FooterText != null || AppData.FooterText != null) ? AppData.FooterText : '',
                border: [false, true, false, false],
                alignment: 'right',
                fontSize: 8,
            }
            ThirdFooterColumn = TextareaDemo;
            FooterWidth.push(rightFooterwidth)
        } else if (RightFooter == 'Accreditation') {
            var FooterimageDemo = {
                image: (logo != null || logo != undefined) ? logo : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANUAAAA8CAYAAADxC//JAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC1SURBVHhe7dMxAQAADMOg+TfdmcgJHrgBKakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpIKYVBCTCmJSQUwqiEkFMakgJhXEpILU9j3E8+v/7ZAlAAAAAElFTkSuQmCC',
                fit: [45, 40],
                border: [false, true, false, false],
                alignment: 'right',
                fontSize: 8,

            }
            ThirdFooterColumn = FooterimageDemo;
            FooterWidth.push(rightFooterwidth)
        } else if (RightFooter == "" || RightFooter == null) {
            var FooternoneDemo = {
                text: (AppData.FooterText == null || AppData.FooterText == null) ? AppData.FooterText : '',
                border: [false, true, false, false],
                alignment: 'left',
                fontSize: 8,

            }
            ThirdFooterColumn = FooternoneDemo;
            FooterWidth.push(rightFooterwidth)
        }

        columndata.push(FirstFooterColumn);
        columndata.push(SecondFooterColumn);
        columndata.push(ThirdFooterColumn);
        FooterBody.push(columndata);
        return FooterBody;
    },

    //Border of Footer layout
    PdfDocFooterBorderLayout: function() {
        var Layout = {
            hLineWidth: function(i, node) {
                return 0.5;
            },
            hLineColor: function(i, node) {
                return 'black';
            }
        }

        return Layout

    },

    //Footer Margin
    Footermargin: function() {
        var AppData = JSON.parse($window.sessionStorage.getItem("AppCofig"));

        var footermargin = []
        var bottommargins = Number(AppData.BottomMargin);
        var footertop = AppData.BottomMargin - 50;
        footermargin.push(Number(AppData.LeftMargin));
        if (bottommargins <= 50) {
            footermargin.push(footertop);
        } else {
            footermargin.push(0);
        }
        footermargin.push(Number(AppData.RightMargin));
        footermargin.push(Number(AppData.FooterFromBottom));
        return footermargin;
    },
    //#endregion

    //#region Master Table Design for Pdf
    MasterTable: function(MasterData) {
        //#region Lining space
        var LineSpace = {
                text: '',
                style: ['lineSpacingheader']
            }
            //#endregion
            //#region Page Title
        var PageTitle = {
                text: MasterData.PageName,
                fontSize: 20,
                alignment: 'center',
                style: ['lineSpacing'],
            }
            //#endregion
            //#region Master Data Functionality
        if (this.isNotUndefindeOrEmpty(MasterData)) {
            var Data = [];
            var Returndata = [];
            //#region Border condition based on the table
            var TableleftTop = [true, true, false, false]
            var TableRightTop = [false, true, true, false]

            var TableleftCenter = [true, false, false, false]
            var TableRightCenter = [false, false, true, false]

            var TableLeftBottom = [true, false, false, true]
            var TableRightBottom = [false, false, true, true]
                //#endregion
            angular.forEach(MasterData.RowProperty, function(key, value) {
                if (value == 0) {
                    var PropertyA = [{
                            text: (key.ColumnA.PropertyName != undefined ? key.ColumnA.PropertyName : ''),
                            border: TableleftTop,
                            fontSize: 10,
                            style: 'RightAlign'

                        },

                        {
                            text: ':',
                            border: [false, true, false, false],
                            fontSize: 10,
                            style: 'RightAlign'
                        },
                        {
                            text: (key.ColumnA.PropertyValue != null ? key.ColumnA.PropertyValue : ''),
                            fontSize: 10,
                            border: TableRightTop,
                        },
                        {
                            border: [false, false, false, false],
                            fontSize: 10,
                            text: ''
                        },

                        {
                            text: (key.ColumnB.PropertyName != undefined ? key.ColumnB.PropertyName : ''),
                            border: TableleftTop,
                            fontSize: 10,
                            style: 'RightAlign'
                        },

                        {
                            text: ':',
                            border: [false, true, false, false],
                            fontSize: 10,
                            style: 'RightAlign'
                        },
                        {
                            text: (key.ColumnB.PropertyValue != null ? key.ColumnB.PropertyValue : ''),
                            fontSize: 10,
                            border: TableRightTop,
                        }
                    ]
                } else if (value == (MasterData.RowProperty.length - 1)) {
                    var PropertyA = [{
                            text: (key.ColumnA.PropertyName != undefined ? key.ColumnA.PropertyName : ''),
                            border: TableLeftBottom,
                            fontSize: 10,
                            style: 'RightAlign'
                        },

                        {
                            text: ':',
                            border: [false, false, false, true],
                            fontSize: 10,
                            style: 'RightAlign'
                        },
                        {
                            text: (key.ColumnA.PropertyValue != null ? key.ColumnA.PropertyValue : ''),
                            fontSize: 10,
                            border: TableRightBottom,
                        },
                        {
                            border: [false, false, false, false],
                            fontSize: 10,
                            text: ''
                        },

                        {
                            text: (key.ColumnB.PropertyName != undefined ? key.ColumnB.PropertyName : ''),
                            border: TableLeftBottom,
                            fontSize: 10,
                            style: 'RightAlign'
                        },

                        {
                            text: ':',
                            border: [false, false, false, true],
                            fontSize: 10,
                            style: 'RightAlign'
                        },
                        {
                            text: (key.ColumnB.PropertyValue != null ? key.ColumnB.PropertyValue : ''),
                            fontSize: 10,
                            border: TableRightBottom,
                        }
                    ]
                } else {
                    var PropertyA = [{
                            text: (key.ColumnA.PropertyName != undefined ? key.ColumnA.PropertyName : ''),
                            border: TableleftCenter,
                            fontSize: 10,
                            style: 'RightAlign'
                        },

                        {
                            text: ':',
                            border: [false, false, false, false],
                            fontSize: 10,
                            style: 'RightAlign'
                        },
                        {
                            text: (key.ColumnA.PropertyValue != null ? key.ColumnA.PropertyValue : ''),
                            fontSize: 10,
                            border: TableRightCenter,
                        },
                        {
                            border: [false, false, false, false],
                            fontSize: 10,
                            text: ''
                        },

                        {
                            text: (key.ColumnB.PropertyName != undefined ? key.ColumnB.PropertyName : ''),
                            border: TableleftCenter,
                            fontSize: 10,
                            style: 'RightAlign'
                        },

                        {
                            text: ':',
                            border: [false, false, false, false],
                            fontSize: 10,
                            style: 'RightAlign'
                        },
                        {
                            text: (key.ColumnB.PropertyValue != null ? key.ColumnB.PropertyValue : ''),
                            fontSize: 10,
                            border: TableRightCenter,
                        }
                    ]
                }
                Data.push(PropertyA);
            })
        }
        var MasterDesign = {
                style: 'MasterTableAlign',
                table: {
                    widths: [75, 6, '38.5%', '0.5%', 80, 6, '27%'],
                    body: Data
                },
                layout: this.PdfDocMasterLayout(),
            }
            //#endregion
            //#region  Empty space
        var EmptySpaceafterTable = {
                text: '',
                style: ['emptylineSpacingAfterTable'],
            }
            //#endregion
        Returndata.push(LineSpace);
        Returndata.push(PageTitle);
        Returndata.push(MasterDesign);
        Returndata.push(EmptySpaceafterTable);
        return Returndata;
    },

    //#endregion
    //#region Grid data
    GridData: function(GridData) {
        var ReturnGridData = []
        var Datarow = []
        angular.forEach(GridData.GridHeader, function(key, value) {
            tempColumn = {
                text: key.CoulmnName,
                style: 'header',
                alignment: 'center',
                fontSize: 10,
                heights: 10,
            }
            Datarow.push(tempColumn)
        })
        GridData.GridValue.splice(0, 0, Datarow);
        var GridValue = {
            table: {
                heights: [10],
                headerRows: 1,
                widths: GridData.widths,

                body: GridData.GridValue
            },
            layout: {
                hLineWidth: function(i, node) {
                    return 0.1;
                },
                vLineWidth: function(i, node) {
                    return 0.1;
                },
                vLineColor: function(i, node) {
                    return 'gray';
                },
                hLineColor: function(i, node, page) {
                    return (i === 0 || i == node.table.body.length || (node.table.body.length == 0 || i == 1 || (i === node.table.body.length - GridData.Layout.FirstLayoutColor) || (i === node.table.body.length - GridData.Layout.SecondlLayoutColor) || (i === node.table.body.length - GridData.Layout.ThirdLayoutColor) || (i === node.table.body.length - GridData.Layout.FourthLayoutColor) || (i === node.table.body.length - GridData.Layout.FifthLayoutColor))) ? 'gray' : 'white';
                },
            },
        }
        ReturnGridData.push(GridValue);
        return ReturnGridData
    },
    //#endregion

    //#region Description Area
    DescriptionArea: function(DescriptionArea) {
        var Returndata = []
        var EmptySpaceafterTable0 = {
            text: '',
            style: ['emptylineSpacingAfterTable'],
        }
        var DescriptionData = {
            style: 'tables',
            table: {
                heights: [5, 5, 5, 5, 5, 5, 5],
                fontSize: 7,
                widths: [75, 6, '80.5%'],
                body: [
                    [{
                            text: DescriptionArea.PropertyName,
                            style: 'bold',
                            fontSize: 10,
                            border: [false, false, false, false],
                        },
                        {
                            text: ' ',
                            fontSize: 10,
                            border: [false, false, false, false],
                        },
                        {
                            border: [false, false, false, false],
                            text: ((DescriptionArea.PropertyValue != null || DescriptionArea.PropertyValue != undefined) ? DescriptionArea.PropertyValue : ''),
                            fontSize: 10,
                        },
                    ],
                ]
            }
        }
        var EmptySpaceafterTable1 = {
            text: '',
            style: ['emptylineSpacingAfterTable'],
        }
        var EmptySpaceafterTable2 = {
            text: '',
            style: ['emptylineSpacingAfterTable'],
        }
        var EmptySpaceafterTable3 = {
            text: '',
            style: ['emptylineSpacingAfterTable'],
        }
        var EmptySpaceafterTable4 = {
            text: '',
            style: ['emptylineSpacingAfterTable'],
        }
        Returndata.push(EmptySpaceafterTable0)
        Returndata.push(DescriptionData)
        Returndata.push(EmptySpaceafterTable1)
        Returndata.push(EmptySpaceafterTable2)
        Returndata.push(EmptySpaceafterTable3)
        Returndata.push(EmptySpaceafterTable4)
        return Returndata
    },

    //#endregion


    DocumentValidater: function(DocumentType, ReferenceNumber) {
        var result = false;

        switch (DocumentType) {
            case "GSTIN":
                result = this.GSTIN_Validater(ReferenceNumber);
                break;
        }
        return result;
    },





    GSTIN_Validater: function(DocRefNo) {
        var gstin = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[0-9a-zA-Z]{1}[0-9a-zA-Z]{1})+$/;
        return (!this.IsNotNullOrEmptyOrUndefined(DocRefNo)) ? false : (gstin.test(DocRefNo)) ? true : false;
    },



    Password_validator: function(Password) {

        var result = false;
        console.log("test");
        // var Small = /[a-z]+/;
        // var Caps = /[A-Z]+/;
        // var min = /.{8,}/;
        // var num = /[0-9]+/;
        var special = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        // var special =  /^[!@#\$%\^\&*\)\(+=._-]+/;
        // if (Small.test(Password) && Caps.test(Password) && min.test(Password) && num.test(Password) && special.test(Password))
        if (special.test(Password))
            result = true;
        else
            result = false;

        return result;
    },

    Password_Validater: function(Password) {
        var result = false;
        var special = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        if (special.test(Password))
            result = true;
        else
            result = false;

        return result;
    },

    //#region Additional Pdf Area(Company name,Customer Signature)
    Additionalarea: function(AdditionalArea) {
        var Additionalarea = {
            style: 'tab3',
            table: {
                heights: [10],
                widths: [110, '25%', 80, 40, '30%'],
                fontSize: 0,
                body: [
                    [{
                            text: AdditionalArea.PropertyName1,
                            alignment: 'left',
                            border: [false, false, false, false],

                        },
                        {
                            text: '',

                            border: [false, false, false, false],

                        },
                        {
                            text: '',
                            border: [false, false, false, false],

                        },
                        {
                            text: '',
                            border: [false, false, false, false],

                        },
                        {
                            text: AdditionalArea.PropertyName2,
                            alignment: 'right',
                            border: [false, false, false, false],
                        },
                    ],

                    [{
                            text: ((AdditionalArea.PropertyValue1 != null || AdditionalArea.PropertyValue1 != undefined) ? AdditionalArea.PropertyValue1 : ''),
                            alignment: 'left',
                            border: [false, false, false, false],
                        },
                        {
                            text: '',
                            border: [false, false, false, false],

                        },
                        {
                            text: '',
                            border: [false, false, false, false],

                        },
                        {
                            text: '',
                            border: [false, false, false, false],

                        },

                        {
                            text: ((AdditionalArea.PropertyValue2 != null || AdditionalArea.PropertyValue2 != undefined || AdditionalArea.PropertyValue2 != "") ? AdditionalArea.PropertyValue2 : ''),
                            alignment: 'right',
                            border: [false, false, false, false],
                        },

                    ],
                ],
            },
            layout: this.PdfDocMasterLayout()

        }
        return Additionalarea
    },
    //#endregion

    //style for (order confimation and delivery note)
    GetPdfCommonStyle: function() {
        return {
            'emptylineSpacingAfterTable': {
                margin: [2, 3, 3, 3],
                // lineHeight: 1.5
            },
            'emptylineSpacingBeforeTable': {
                margin: [10, 1, 10, 10]
            },
            'pdfbankstyle': {
                margin: [2, 3, 3, 3],
                lineHeight: 1.5
            },
            'emptylineSpacing': {
                margin: [50, 50, 50, 30]
            },
            'lineSpacing': {
                margin: [35, -20, 50, 10],
            },
            'lineSpacingheader': {
                margin: [35, -20, 50, 10]
            },
            'doublelineSpacing': {
                margin: [0, 0, 0, 12]
            },
            'headingColor': {
                color: '#999966'
            },
            Rightalign: {
                alignment: 'right',
                fontSize: 10,
            },
            subheader2: {
                fontSize: 10,
                alignment: 'left',
                bold: true,
                margin: [0, -3, 0, -30]
            },
            header: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                margin: [0, 4, 0, 3]
            },
            bold: {
                bold: true,
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: '#669999'
            },
            Leftalign: {
                fontSize: 10,
                alignment: 'left',

            },
            section: {
                fontSize: 9,
                margin: [0, 15, 0, 5]
            },
            MasterTableAlign: {
                absolutePosition: {
                    x: 250,
                    y: 250
                },
                image: {
                    alignment: 'center',
                    margin: [10, 5, 10, 10]
                },
                margin: [0, -10, 0, 0]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            },
            table: {
                heights: [20, 20, 20, 20, 20, 20],
                widths: [100, 150, 100, 100, 50, 100],
                border: [true, true, false, false],
            }
        }
    },

    // when double quote replace to para symbol
    escape: function(data) {
        if (data != null && data != undefined && data != '' && data != 'null') {
            return data = data.replace(/"/g, "¶");
        }
    },


    // when double quote replace to para symbol
    ClearAutoComplete: function(ControlId) {
        document.getElementById(ControlId).value = null;
    },

    // when para symbol replace to double quote and new Break line apply
    unescape: function(data) {

        if (data != null && data != undefined && data != '' && data != 'null') {
            return data.replace(new RegExp('¶', 'g'), '"');
        } else {
            return data;
        }
    },

    daysbetween(date1, date2) {

        if (!date1)
            date1 = new Date();
        if (!date2)
            date1 = new Date();

        date1 = new Date(date1);
        date2 = new Date(date2);

        var DateOneDate = date1.getDate();
        var DateOneMonth = date1.getMonth();
        var DateOneYear = date1.getFullYear();

        var DateOne = new Date(DateOneYear, DateOneMonth, DateOneDate);

        var DateTwoDate = date2.getDate();
        var DateTwoMonth = date2.getMonth();
        var DateTwoYear = date2.getFullYear();

        var DateTwo = new Date(DateTwoYear, DateTwoMonth, DateTwoDate);

        // The number of milliseconds in one day
        var ONE_DAY = 1000 * 60 * 60 * 24

        // Convert both dates to milliseconds
        var date1_ms = DateOne.getTime()
        var date2_ms = DateTwo.getTime()

        // Calculate the difference in milliseconds
        var difference_ms = Math.abs(date1_ms - date2_ms)

        // Convert back to days and return
        return Math.round(difference_ms / ONE_DAY)

    },
    // Method from 29-08-2019
    deleteFunctionality: function(List, deletedObj) {
        var arr, attr, value;
        var result = false;
        arr = List;
        var i = arr.length;
        if (this.IsNotNullOrEmptyOrUndefined(deletedObj.rowId) || deletedObj.rowId == 0) {
            attr = 'rowId';
            value = deletedObj.rowId;
            while (i--) {
                if (arr[i] && arr[i].hasOwnProperty(attr) && (arguments.length == 2 && arr[i][attr] === value)) {
                    arr.splice(i, 1);
                    result = true;
                }
            }
        }
        return result;
    },

    deleteFunctionalityEdit: function(List, deletedObj) {
        var arr, attr, value;
        var result = false;
        arr = List;
        var i = arr.length;

        if (deletedObj.Id != undefined)
            attr = "Id";
        else if (deletedObj.rowId != undefined)
            attr = "rowId";
        else if (deletedObj.ID != undefined)
            attr = "ID";

        console.log("delete");
        if (this.IsNotNullOrEmptyOrUndefined(deletedObj[attr]) || deletedObj[attr] == 0) {
            value = deletedObj[attr];
            while (i--) {
                if (arr[i] && arr[i].hasOwnProperty(attr) && (arguments.length == 2 && arr[i][attr] === value)) {
                    arr.splice(i, 1);
                    result = true;
                }
            }
        }
        return result;
    },

    tabDefaultState: function(TabInfo) {
        TabInfo.TabDetails.filter(function(item) {
            if (item.isDefaultSelectedTab) {
                var element = document.getElementById(item.id);
                element.classList.add("tabChecked-tablabel");
                item.isTabEnable = true;
            } else if (item.isDisabled) {
                var element = document.getElementById(item.id);
                element.classList.add("V-tab-disabled");
            } else {
                var removedElement = document.getElementById(item.id);
                for (var i = 0; i < removedElement.classList.length; i++) {
                    if (removedElement.classList[i] == "tabChecked-tablabel") {
                        removedElement.classList.remove("tabChecked-tablabel");
                        item.isTabEnable = false;
                    }
                }
            }
        })
    },

    DecimalRestrict: function($event, attr) {

        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || attr.indexOf(".") != -1)) {
            $event.preventDefault();
        }
        if (attr != null && attr.indexOf(".") > -1 && attr.split(".")[1].length > 1) {
            $event.preventDefault();
        }
    },

    sortObject: function(data) {
        console.log("sort");
        //   Object.keys(data).forEach(function (key) {
        //     var value = data[key];
        //     newObject[key] = value * value;
        // });
        var keys = Object.keys(data);
        var result = {};

        keys.sort();

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            result[key] = data[key];
        }

        return result;
    },

    stringsort: function(str) {
        var i = 0,
            j;
        while (i < str.length) {
            j = i + 1;
            while (j < str.length) {
                if (str[j] < str[i]) {
                    var temp = str[i];
                    str[i] = str[j];
                    str[j] = temp;
                }
                j++;
            }
            i++;
        }
    },

    decimalToNear: function(number) {
        console.log("number");
        number = Math.ceil(number);
        return number;
    },

    convertToThousandSeparator: function(number) {
        console.log("convertToThousandSeparator");
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    //#endregion

    makeCell: function(content, options = {}) {
        return Object.assign({ text: content, fillColor: 'white' }, options);
    },


    thl: function(content, options = {}) {
        return this.makeCell(content, Object.assign({ bold: true, alignment: 'left', fontSize: 11 }, options));
    },

    thr: function(content, options = {}) {
        return this.makeCell(content, Object.assign({ bold: true, alignment: 'right', fontSize: 11 }, options));
    },

    tdl: function(content, options = {}) {
        return this.makeCell(content, Object.assign({ bold: false, alignment: 'left', fontSize: 11 }, options));
    },

    tdr: function(content, options = {}) {
        return this.makeCell(content, Object.assign({ bold: false, alignment: 'right', fontSize: 11 }, options));
    },

    tdd: function(content, options = {}) {
        return this.makeCell(content, Object.assign({ bold: false, alignment: 'center', fontSize: 11 }, options));
    },

    thh: function(content, options = {}) {
        return this.makeCell(content, Object.assign({ bold: true, lineHeight: 2, alignment: 'center', fontSize: 13 }, options));
    },

    getnull: function(data) {
        if (data == null)
            data = "";

        return data;

    },
    updateOptions: function(chartId, chartOption) {
        ApexCharts.exec(chartId, 'updateOptions', chartOption, false, true);
    },

    updateSeries: function(chartId, Series) {
        ApexCharts.exec(chartId, 'updateSeries', Series, true);
    },

    SetFocus: function(id) {
        document.getElementById(id).focus();
    }

};
